import { TopicDictionary } from '../model/types';

export const iptc: Array<TopicDictionary> = [
  {
    label: 'arts, culture and entertainment',
    parent: null,
    id: '01000000',
    hierarchicalLabel: 'arts, culture and entertainment'
  },
  {
    label: 'arts and entertainment',
    parent: '01000000',
    id: '20000002',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment'
  },
  {
    label: 'animation',
    parent: '20000002',
    id: '20000003',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>animation'
  },
  {
    label: 'cartoon',
    parent: '20000002',
    id: '20000004',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>cartoon'
  },
  {
    label: 'cinema',
    parent: '20000002',
    id: '20000005',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>cinema'
  },
  {
    label: 'film festival',
    parent: '20000005',
    id: '20000006',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>cinema>film festival'
  },
  {
    label: 'dance',
    parent: '20000002',
    id: '20000007',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>dance'
  },
  {
    label: 'ballet',
    parent: '20000007',
    id: '20000008',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>dance>ballet'
  },
  {
    label: 'modern dance',
    parent: '20000007',
    id: '20000009',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>dance>modern dance'
  },
  {
    label: 'traditional dance',
    parent: '20000007',
    id: '20000010',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>dance>traditional dance'
  },
  {
    label: 'fashion',
    parent: '20000002',
    id: '20000011',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>fashion'
  },
  {
    label: 'jewellery',
    parent: '20000011',
    id: '20000012',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>fashion>jewellery'
  },
  {
    label: 'literature',
    parent: '20000002',
    id: '20000013',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>literature'
  },
  {
    label: 'drama (literature)',
    parent: '20000013',
    id: '20000014',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>literature>drama (literature)'
  },
  {
    label: 'fiction',
    parent: '20000013',
    id: '20000015',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>literature>fiction'
  },
  {
    label: 'non-fiction',
    parent: '20000013',
    id: '20000016',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>literature>non-fiction'
  },
  {
    label: 'poetry',
    parent: '20000013',
    id: '20000017',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>literature>poetry'
  },
  {
    label: 'music',
    parent: '20000002',
    id: '20000018',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>music'
  },
  {
    label: 'musical instrument',
    parent: '20000018',
    id: '20000019',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>music>musical instrument'
  },
  {
    label: 'musical performance',
    parent: '20000018',
    id: '20000020',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>music>musical performance'
  },
  {
    label: 'musical style',
    parent: '20000018',
    id: '20000021',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>music>musical style'
  },
  {
    label: 'classical music',
    parent: '20000021',
    id: '20000022',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>music>musical style>classical music'
  },
  {
    label: 'country music',
    parent: '20000021',
    id: '20000023',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>music>musical style>country music'
  },
  {
    label: 'folk music',
    parent: '20000021',
    id: '20000024',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>music>musical style>folk music'
  },
  {
    label: 'jazz music',
    parent: '20000021',
    id: '20000025',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>music>musical style>jazz music'
  },
  {
    label: 'popular music',
    parent: '20000021',
    id: '20000026',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>music>musical style>popular music'
  },
  {
    label: 'rock and roll music',
    parent: '20000021',
    id: '20000027',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>music>musical style>rock and roll music'
  },
  {
    label: 'opera',
    parent: '20000002',
    id: '20000028',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>opera'
  },
  {
    label: 'theatre',
    parent: '20000002',
    id: '20000029',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>theatre'
  },
  {
    label: 'music theatre',
    parent: '20000029',
    id: '20000030',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>theatre>music theatre'
  },
  {
    label: 'musical',
    parent: '20000030',
    id: '20001133',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>theatre>music theatre>musical'
  },
  {
    label: 'operetta',
    parent: '20000030',
    id: '20001134',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>theatre>music theatre>operetta'
  },
  {
    label: 'visual arts',
    parent: '20000002',
    id: '20000031',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>visual arts'
  },
  {
    label: 'architecture',
    parent: '20000031',
    id: '20000032',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>visual arts>architecture'
  },
  {
    label: 'design (visual arts)',
    parent: '20000031',
    id: '20000033',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>visual arts>design (visual arts)'
  },
  {
    label: 'drawing',
    parent: '20000031',
    id: '20000034',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>visual arts>drawing'
  },
  {
    label: 'painting',
    parent: '20000031',
    id: '20000035',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>visual arts>painting'
  },
  {
    label: 'photography',
    parent: '20000031',
    id: '20000036',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>visual arts>photography'
  },
  {
    label: 'sculpture',
    parent: '20000031',
    id: '20000037',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>visual arts>sculpture'
  },
  {
    label: 'art exhibition',
    parent: '20000002',
    id: '20001135',
    hierarchicalLabel: 'arts, culture and entertainment>arts and entertainment>art exhibition'
  },
  {
    label: 'culture',
    parent: '01000000',
    id: '20000038',
    hierarchicalLabel: 'arts, culture and entertainment>culture'
  },
  {
    label: 'cultural development',
    parent: '20000038',
    id: '20000039',
    hierarchicalLabel: 'arts, culture and entertainment>culture>cultural development'
  },
  {
    label: 'customs and tradition',
    parent: '20000038',
    id: '20000040',
    hierarchicalLabel: 'arts, culture and entertainment>culture>customs and tradition'
  },
  {
    label: 'festive event (culture)',
    parent: '20000038',
    id: '20000041',
    hierarchicalLabel: 'arts, culture and entertainment>culture>festive event (culture)'
  },
  {
    label: 'language',
    parent: '20000038',
    id: '20000042',
    hierarchicalLabel: 'arts, culture and entertainment>culture>language'
  },
  {
    label: 'library and museum',
    parent: '20000038',
    id: '20000043',
    hierarchicalLabel: 'arts, culture and entertainment>culture>library and museum'
  },
  {
    label: 'monument and heritage site',
    parent: '20000038',
    id: '20000044',
    hierarchicalLabel: 'arts, culture and entertainment>culture>monument and heritage site'
  },
  {
    label: 'mass media',
    parent: '01000000',
    id: '20000045',
    hierarchicalLabel: 'arts, culture and entertainment>mass media'
  },
  {
    label: 'news media',
    parent: '20000045',
    id: '20000046',
    hierarchicalLabel: 'arts, culture and entertainment>mass media>news media'
  },
  {
    label: 'newspaper',
    parent: '20000045',
    id: '20000047',
    hierarchicalLabel: 'arts, culture and entertainment>mass media>newspaper'
  },
  {
    label: 'online media',
    parent: '20000045',
    id: '20000048',
    hierarchicalLabel: 'arts, culture and entertainment>mass media>online media'
  },
  {
    label: 'periodical',
    parent: '20000045',
    id: '20000049',
    hierarchicalLabel: 'arts, culture and entertainment>mass media>periodical'
  },
  {
    label: 'radio',
    parent: '20000045',
    id: '20000050',
    hierarchicalLabel: 'arts, culture and entertainment>mass media>radio'
  },
  {
    label: 'television',
    parent: '20000045',
    id: '20000051',
    hierarchicalLabel: 'arts, culture and entertainment>mass media>television'
  },
  {
    label: 'crime, law and justice',
    parent: null,
    id: '02000000',
    hierarchicalLabel: 'crime, law and justice'
  },
  {
    label: 'crime',
    parent: '02000000',
    id: '20000082',
    hierarchicalLabel: 'crime, law and justice>crime'
  },
  {
    label: 'arson',
    parent: '20000082',
    id: '20000083',
    hierarchicalLabel: 'crime, law and justice>crime>arson'
  },
  {
    label: 'assault',
    parent: '20000082',
    id: '20000084',
    hierarchicalLabel: 'crime, law and justice>crime>assault'
  },
  {
    label: 'sexual assault',
    parent: '20000084',
    id: '20000085',
    hierarchicalLabel: 'crime, law and justice>crime>assault>sexual assault'
  },
  {
    label: 'computer crime',
    parent: '20000082',
    id: '20000086',
    hierarchicalLabel: 'crime, law and justice>crime>computer crime'
  },
  {
    label: 'corporate crime',
    parent: '20000082',
    id: '20000087',
    hierarchicalLabel: 'crime, law and justice>crime>corporate crime'
  },
  {
    label: 'anti-trust crime',
    parent: '20000087',
    id: '20000088',
    hierarchicalLabel: 'crime, law and justice>crime>corporate crime>anti-trust crime'
  },
  {
    label: 'breach of contract',
    parent: '20000087',
    id: '20000089',
    hierarchicalLabel: 'crime, law and justice>crime>corporate crime>breach of contract'
  },
  {
    label: 'embezzlement',
    parent: '20000087',
    id: '20000090',
    hierarchicalLabel: 'crime, law and justice>crime>corporate crime>embezzlement'
  },
  {
    label: 'insider trading',
    parent: '20000087',
    id: '20000091',
    hierarchicalLabel: 'crime, law and justice>crime>corporate crime>insider trading'
  },
  {
    label: 'restraint of trade',
    parent: '20000087',
    id: '20000092',
    hierarchicalLabel: 'crime, law and justice>crime>corporate crime>restraint of trade'
  },
  {
    label: 'corruption',
    parent: '20000082',
    id: '20000093',
    hierarchicalLabel: 'crime, law and justice>crime>corruption'
  },
  {
    label: 'bribery',
    parent: '20000093',
    id: '20000094',
    hierarchicalLabel: 'crime, law and justice>crime>corruption>bribery'
  },
  {
    label: 'drug related crimes',
    parent: '20000082',
    id: '20000095',
    hierarchicalLabel: 'crime, law and justice>crime>drug related crimes'
  },
  {
    label: 'drug trafficking',
    parent: '20000095',
    id: '20000096',
    hierarchicalLabel: 'crime, law and justice>crime>drug related crimes>drug trafficking'
  },
  {
    label: 'fraud',
    parent: '20000082',
    id: '20000097',
    hierarchicalLabel: 'crime, law and justice>crime>fraud'
  },
  {
    label: 'hijacking',
    parent: '20000082',
    id: '20000098',
    hierarchicalLabel: 'crime, law and justice>crime>hijacking'
  },
  {
    label: 'homicide',
    parent: '20000082',
    id: '20000099',
    hierarchicalLabel: 'crime, law and justice>crime>homicide'
  },
  {
    label: 'kidnapping',
    parent: '20000082',
    id: '20000100',
    hierarchicalLabel: 'crime, law and justice>crime>kidnapping'
  },
  {
    label: 'organised crime',
    parent: '20000082',
    id: '20000101',
    hierarchicalLabel: 'crime, law and justice>crime>organised crime'
  },
  {
    label: 'gang activity',
    parent: '20000101',
    id: '20000102',
    hierarchicalLabel: 'crime, law and justice>crime>organised crime>gang activity'
  },
  {
    label: 'terrorism',
    parent: '20000082',
    id: '20000103',
    hierarchicalLabel: 'crime, law and justice>crime>terrorism'
  },
  {
    label: 'theft',
    parent: '20000082',
    id: '20000104',
    hierarchicalLabel: 'crime, law and justice>crime>theft'
  },
  {
    label: 'war crime',
    parent: '20000082',
    id: '20000105',
    hierarchicalLabel: 'crime, law and justice>crime>war crime'
  },
  {
    label: 'judiciary',
    parent: '02000000',
    id: '20000106',
    hierarchicalLabel: 'crime, law and justice>judiciary'
  },
  {
    label: 'court',
    parent: '20000106',
    id: '20000107',
    hierarchicalLabel: 'crime, law and justice>judiciary>court'
  },
  {
    label: 'appeal (court)',
    parent: '20000107',
    id: '20000108',
    hierarchicalLabel: 'crime, law and justice>judiciary>court>appeal (court)'
  },
  {
    label: 'court administration',
    parent: '20000107',
    id: '20000109',
    hierarchicalLabel: 'crime, law and justice>judiciary>court>court administration'
  },
  {
    label: 'judge',
    parent: '20000107',
    id: '20000110',
    hierarchicalLabel: 'crime, law and justice>judiciary>court>judge'
  },
  {
    label: 'trial (court)',
    parent: '20000107',
    id: '20000111',
    hierarchicalLabel: 'crime, law and justice>judiciary>court>trial (court)'
  },
  {
    label: 'court preliminary',
    parent: '20000111',
    id: '20000112',
    hierarchicalLabel: 'crime, law and justice>judiciary>court>trial (court)>court preliminary'
  },
  {
    label: 'defendant',
    parent: '20000111',
    id: '20000113',
    hierarchicalLabel: 'crime, law and justice>judiciary>court>trial (court)>defendant'
  },
  {
    label: 'litigation',
    parent: '20000111',
    id: '20000114',
    hierarchicalLabel: 'crime, law and justice>judiciary>court>trial (court)>litigation'
  },
  {
    label: 'witness',
    parent: '20000111',
    id: '20000115',
    hierarchicalLabel: 'crime, law and justice>judiciary>court>trial (court)>witness'
  },
  {
    label: 'out of court procedures',
    parent: '20000106',
    id: '20000116',
    hierarchicalLabel: 'crime, law and justice>judiciary>out of court procedures'
  },
  {
    label: 'arbitration',
    parent: '20000116',
    id: '20000117',
    hierarchicalLabel: 'crime, law and justice>judiciary>out of court procedures>arbitration'
  },
  {
    label: 'prosecution',
    parent: '20000106',
    id: '20000118',
    hierarchicalLabel: 'crime, law and justice>judiciary>prosecution'
  },
  {
    label: 'justice and rights',
    parent: '02000000',
    id: '20000119',
    hierarchicalLabel: 'crime, law and justice>justice and rights'
  },
  {
    label: 'civil rights',
    parent: '20000119',
    id: '20000120',
    hierarchicalLabel: 'crime, law and justice>justice and rights>civil rights'
  },
  {
    label: 'law',
    parent: '02000000',
    id: '20000121',
    hierarchicalLabel: 'crime, law and justice>law'
  },
  {
    label: 'civil law',
    parent: '20000121',
    id: '20000122',
    hierarchicalLabel: 'crime, law and justice>law>civil law'
  },
  {
    label: 'antitrust issue',
    parent: '20000122',
    id: '20000123',
    hierarchicalLabel: 'crime, law and justice>law>civil law>antitrust issue'
  },
  {
    label: 'regulation',
    parent: '20000122',
    id: '20000124',
    hierarchicalLabel: 'crime, law and justice>law>civil law>regulation'
  },
  {
    label: 'criminal law',
    parent: '20000121',
    id: '20000125',
    hierarchicalLabel: 'crime, law and justice>law>criminal law'
  },
  {
    label: 'international law',
    parent: '20000121',
    id: '20000126',
    hierarchicalLabel: 'crime, law and justice>law>international law'
  },
  {
    label: 'extradition',
    parent: '20000126',
    id: '20000127',
    hierarchicalLabel: 'crime, law and justice>law>international law>extradition'
  },
  {
    label: 'international court or tribunal',
    parent: '20000126',
    id: '20000128',
    hierarchicalLabel: 'crime, law and justice>law>international law>international court or tribunal'
  },
  {
    label: 'law enforcement',
    parent: '02000000',
    id: '20000129',
    hierarchicalLabel: 'crime, law and justice>law enforcement'
  },
  {
    label: 'arrest',
    parent: '20000129',
    id: '20000130',
    hierarchicalLabel: 'crime, law and justice>law enforcement>arrest'
  },
  {
    label: 'investigation (criminal)',
    parent: '20000129',
    id: '20000131',
    hierarchicalLabel: 'crime, law and justice>law enforcement>investigation (criminal)'
  },
  {
    label: 'missing person',
    parent: '20000131',
    id: '20000132',
    hierarchicalLabel: 'crime, law and justice>law enforcement>investigation (criminal)>missing person'
  },
  {
    label: 'police',
    parent: '20000129',
    id: '20000133',
    hierarchicalLabel: 'crime, law and justice>law enforcement>police'
  },
  {
    label: 'punishment (criminal)',
    parent: '20000129',
    id: '20000134',
    hierarchicalLabel: 'crime, law and justice>law enforcement>punishment (criminal)'
  },
  {
    label: 'capital punishment',
    parent: '20000134',
    id: '20000135',
    hierarchicalLabel: 'crime, law and justice>law enforcement>punishment (criminal)>capital punishment'
  },
  {
    label: 'fine (penalty)',
    parent: '20000134',
    id: '20000136',
    hierarchicalLabel: 'crime, law and justice>law enforcement>punishment (criminal)>fine (penalty)'
  },
  {
    label: 'prison',
    parent: '20000134',
    id: '20000137',
    hierarchicalLabel: 'crime, law and justice>law enforcement>punishment (criminal)>prison'
  },
  {
    label: 'disaster, accident and emergency incident',
    parent: null,
    id: '03000000',
    hierarchicalLabel: 'disaster, accident and emergency incident'
  },
  {
    label: 'accident and emergency incident',
    parent: '03000000',
    id: '20000139',
    hierarchicalLabel: 'disaster, accident and emergency incident>accident and emergency incident'
  },
  {
    label: 'explosion accident and incident',
    parent: '20000139',
    id: '20000140',
    hierarchicalLabel: 'disaster, accident and emergency incident>accident and emergency incident>explosion accident and incident'
  },
  {
    label: 'industrial accident and incident',
    parent: '20000139',
    id: '20000141',
    hierarchicalLabel: 'disaster, accident and emergency incident>accident and emergency incident>industrial accident and incident'
  },
  {
    label: 'nuclear accident and incident',
    parent: '20000141',
    id: '20000142',
    hierarchicalLabel: `disaster, accident and emergency incident>accident and
      emergency incident>industrial accident and incident>nuclear accident and incident`
  },
  {
    label: 'transport accident and incident',
    parent: '20000139',
    id: '20000143',
    hierarchicalLabel: 'disaster, accident and emergency incident>accident and emergency incident>transport accident and incident'
  },
  {
    label: 'air and space accident and incident',
    parent: '20000143',
    id: '20000144',
    hierarchicalLabel: `disaster, accident and emergency incident>accident and emergency incident>transport accident and
      incident>air and space accident and incident`
  },
  {
    label: 'maritime accident and incident',
    parent: '20000143',
    id: '20000145',
    hierarchicalLabel: `disaster, accident and emergency incident>accident and emergency incident>transport
      accident and incident>maritime accident and incident`
  },
  {
    label: 'railway accident and incident',
    parent: '20000143',
    id: '20000146',
    hierarchicalLabel: `disaster, accident and emergency incident>accident and emergency incident>transport accident and
      incident>railway accident and incident`
  },
  {
    label: 'road accident and incident',
    parent: '20000143',
    id: '20000147',
    hierarchicalLabel:
      'disaster, accident and emergency incident>accident and emergency incident>transport accident and incident>road accident and incident'
  },
  {
    label: 'structural failures',
    parent: '20000139',
    id: '20000161',
    hierarchicalLabel: 'disaster, accident and emergency incident>accident and emergency incident>structural failures'
  },
  {
    label: 'disaster',
    parent: '03000000',
    id: '20000148',
    hierarchicalLabel: 'disaster, accident and emergency incident>disaster'
  },
  {
    label: 'famine',
    parent: '20000148',
    id: '20000149',
    hierarchicalLabel: 'disaster, accident and emergency incident>disaster>famine'
  },
  {
    label: 'fire',
    parent: '20000148',
    id: '20000150',
    hierarchicalLabel: 'disaster, accident and emergency incident>disaster>fire'
  },
  {
    label: 'natural disasters',
    parent: '20000148',
    id: '20000151',
    hierarchicalLabel: 'disaster, accident and emergency incident>disaster>natural disasters'
  },
  {
    label: 'drought',
    parent: '20000151',
    id: '20000152',
    hierarchicalLabel: 'disaster, accident and emergency incident>disaster>natural disasters>drought'
  },
  {
    label: 'earthquake',
    parent: '20000151',
    id: '20000153',
    hierarchicalLabel: 'disaster, accident and emergency incident>disaster>natural disasters>earthquake'
  },
  {
    label: 'flood',
    parent: '20000151',
    id: '20000154',
    hierarchicalLabel: 'disaster, accident and emergency incident>disaster>natural disasters>flood'
  },
  {
    label: 'landslide',
    parent: '20000151',
    id: '20000155',
    hierarchicalLabel: 'disaster, accident and emergency incident>disaster>natural disasters>landslide'
  },
  {
    label: 'avalanche',
    parent: '20000155',
    id: '20000156',
    hierarchicalLabel: 'disaster, accident and emergency incident>disaster>natural disasters>landslide>avalanche'
  },
  {
    label: 'meteorological disaster',
    parent: '20000151',
    id: '20000157',
    hierarchicalLabel: 'disaster, accident and emergency incident>disaster>natural disasters>meteorological disaster'
  },
  {
    label: 'windstorms',
    parent: '20000157',
    id: '20000158',
    hierarchicalLabel: 'disaster, accident and emergency incident>disaster>natural disasters>meteorological disaster>windstorms'
  },
  {
    label: 'volcanic eruption',
    parent: '20000151',
    id: '20000159',
    hierarchicalLabel: 'disaster, accident and emergency incident>disaster>natural disasters>volcanic eruption'
  },
  {
    label: 'emergency incident',
    parent: '03000000',
    id: '20000160',
    hierarchicalLabel: 'disaster, accident and emergency incident>emergency incident'
  },
  {
    label: 'transport incident',
    parent: '20000160',
    id: '20000162',
    hierarchicalLabel: 'disaster, accident and emergency incident>emergency incident>transport incident'
  },
  {
    label: 'air and space incident',
    parent: '20000162',
    id: '20000163',
    hierarchicalLabel: 'disaster, accident and emergency incident>emergency incident>transport incident>air and space incident'
  },
  {
    label: 'maritime incident',
    parent: '20000162',
    id: '20000164',
    hierarchicalLabel: 'disaster, accident and emergency incident>emergency incident>transport incident>maritime incident'
  },
  {
    label: 'railway incident',
    parent: '20000162',
    id: '20000165',
    hierarchicalLabel: 'disaster, accident and emergency incident>emergency incident>transport incident>railway incident'
  },
  {
    label: 'road incident',
    parent: '20000162',
    id: '20000166',
    hierarchicalLabel: 'disaster, accident and emergency incident>emergency incident>transport incident>road incident'
  },
  {
    label: 'emergency planning',
    parent: '03000000',
    id: '20000167',
    hierarchicalLabel: 'disaster, accident and emergency incident>emergency planning'
  },
  {
    label: 'emergency response',
    parent: '03000000',
    id: '20000168',
    hierarchicalLabel: 'disaster, accident and emergency incident>emergency response'
  },
  {
    label: 'economy, business and finance',
    parent: null,
    id: '04000000',
    hierarchicalLabel: 'economy, business and finance'
  },
  {
    label: 'business information',
    parent: '04000000',
    id: '20000170',
    hierarchicalLabel: 'economy, business and finance>business information'
  },
  {
    label: 'business finance',
    parent: '20000170',
    id: '20000171',
    hierarchicalLabel: 'economy, business and finance>business information>business finance'
  },
  {
    label: 'accounting and audit',
    parent: '20000171',
    id: '20000172',
    hierarchicalLabel: 'economy, business and finance>business information>business finance>accounting and audit'
  },
  {
    label: 'analysts comment',
    parent: '20000171',
    id: '20000173',
    hierarchicalLabel: 'economy, business and finance>business information>business finance>analysts comment'
  },
  {
    label: 'bankruptcy',
    parent: '20000171',
    id: '20000174',
    hierarchicalLabel: 'economy, business and finance>business information>business finance>bankruptcy'
  },
  {
    label: 'buyback',
    parent: '20000171',
    id: '20000175',
    hierarchicalLabel: 'economy, business and finance>business information>business finance>buyback'
  },
  {
    label: 'credit rating',
    parent: '20000171',
    id: '20000176',
    hierarchicalLabel: 'economy, business and finance>business information>business finance>credit rating'
  },
  {
    label: 'dividend announcement',
    parent: '20000171',
    id: '20000177',
    hierarchicalLabel: 'economy, business and finance>business information>business finance>dividend announcement'
  },
  {
    label: 'earnings',
    parent: '20000171',
    id: '20000178',
    hierarchicalLabel: 'economy, business and finance>business information>business finance>earnings'
  },
  {
    label: 'earnings forecast',
    parent: '20000178',
    id: '20000179',
    hierarchicalLabel: 'economy, business and finance>business information>business finance>earnings>earnings forecast'
  },
  {
    label: 'financial statement',
    parent: '20000171',
    id: '20000180',
    hierarchicalLabel: 'economy, business and finance>business information>business finance>financial statement'
  },
  {
    label: 'proxy filing',
    parent: '20000180',
    id: '20000181',
    hierarchicalLabel: 'economy, business and finance>business information>business finance>financial statement>proxy filing'
  },
  {
    label: 'financially distressed company',
    parent: '20000171',
    id: '20000182',
    hierarchicalLabel: 'economy, business and finance>business information>business finance>financially distressed company'
  },
  {
    label: 'financing and stock offering',
    parent: '20000171',
    id: '20000183',
    hierarchicalLabel: 'economy, business and finance>business information>business finance>financing and stock offering'
  },
  {
    label: 'restructuring and recapitalisation',
    parent: '20000171',
    id: '20000184',
    hierarchicalLabel: 'economy, business and finance>business information>business finance>restructuring and recapitalisation'
  },
  {
    label: 'shareholder',
    parent: '20000171',
    id: '20000185',
    hierarchicalLabel: 'economy, business and finance>business information>business finance>shareholder'
  },
  {
    label: 'stock activity',
    parent: '20000171',
    id: '20000186',
    hierarchicalLabel: 'economy, business and finance>business information>business finance>stock activity'
  },
  {
    label: 'stock flotation',
    parent: '20000171',
    id: '20000187',
    hierarchicalLabel: 'economy, business and finance>business information>business finance>stock flotation'
  },
  {
    label: 'human resources',
    parent: '20000170',
    id: '20000188',
    hierarchicalLabel: 'economy, business and finance>business information>human resources'
  },
  {
    label: 'layoffs and downsizing',
    parent: '20000188',
    id: '20000189',
    hierarchicalLabel: 'economy, business and finance>business information>human resources>layoffs and downsizing'
  },
  {
    label: 'management',
    parent: '20000188',
    id: '20000190',
    hierarchicalLabel: 'economy, business and finance>business information>human resources>management'
  },
  {
    label: 'stock option',
    parent: '20000188',
    id: '20000191',
    hierarchicalLabel: 'economy, business and finance>business information>human resources>stock option'
  },
  {
    label: 'strategy and marketing',
    parent: '20000170',
    id: '20000192',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing'
  },
  {
    label: 'annual and special corporate meeting',
    parent: '20000192',
    id: '20000193',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing>annual and special corporate meeting'
  },
  {
    label: 'annual report',
    parent: '20000192',
    id: '20000194',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing>annual report'
  },
  {
    label: 'board of directors',
    parent: '20000192',
    id: '20000195',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing>board of directors'
  },
  {
    label: 'commercial contract',
    parent: '20000192',
    id: '20000196',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing>commercial contract'
  },
  {
    label: 'company spin-off',
    parent: '20000192',
    id: '20000197',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing>company spin-off'
  },
  {
    label: 'economic globalisation',
    parent: '20000192',
    id: '20000198',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing>economic globalisation'
  },
  {
    label: 'business governance',
    parent: '20000192',
    id: '20000199',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing>business governance'
  },
  {
    label: 'joint venture',
    parent: '20000192',
    id: '20000200',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing>joint venture'
  },
  {
    label: 'leveraged buyout',
    parent: '20000192',
    id: '20000201',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing>leveraged buyout'
  },
  {
    label: 'licensing agreement',
    parent: '20000192',
    id: '20000202',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing>licensing agreement'
  },
  {
    label: 'management buyout',
    parent: '20000192',
    id: '20000203',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing>management buyout'
  },
  {
    label: 'merger or acquisition',
    parent: '20000192',
    id: '20000204',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing>merger or acquisition'
  },
  {
    label: 'new product or service',
    parent: '20000192',
    id: '20000205',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing>new product or service'
  },
  {
    label: 'patent, copyright and trademark',
    parent: '20000192',
    id: '20000206',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing>patent, copyright and trademark'
  },
  {
    label: 'product recall',
    parent: '20000192',
    id: '20000207',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing>product recall'
  },
  {
    label: 'research and development',
    parent: '20000192',
    id: '20000208',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing>research and development'
  },
  {
    label: 'public contract',
    parent: '20000192',
    id: '20001159',
    hierarchicalLabel: 'economy, business and finance>business information>strategy and marketing>public contract'
  },
  {
    label: 'economic sector',
    parent: '04000000',
    id: '20000209',
    hierarchicalLabel: 'economy, business and finance>economic sector'
  },
  {
    label: 'agriculture',
    parent: '20000209',
    id: '20000210',
    hierarchicalLabel: 'economy, business and finance>economic sector>agriculture'
  },
  {
    label: 'aquaculture',
    parent: '20000210',
    id: '20000211',
    hierarchicalLabel: 'economy, business and finance>economic sector>agriculture>aquaculture'
  },
  {
    label: 'arable farming',
    parent: '20000210',
    id: '20000212',
    hierarchicalLabel: 'economy, business and finance>economic sector>agriculture>arable farming'
  },
  {
    label: 'fishing industry',
    parent: '20000210',
    id: '20000213',
    hierarchicalLabel: 'economy, business and finance>economic sector>agriculture>fishing industry'
  },
  {
    label: 'forestry and timber',
    parent: '20000210',
    id: '20000214',
    hierarchicalLabel: 'economy, business and finance>economic sector>agriculture>forestry and timber'
  },
  {
    label: 'livestock farming',
    parent: '20000210',
    id: '20000215',
    hierarchicalLabel: 'economy, business and finance>economic sector>agriculture>livestock farming'
  },
  {
    label: 'viniculture',
    parent: '20000210',
    id: '20000216',
    hierarchicalLabel: 'economy, business and finance>economic sector>agriculture>viniculture'
  },
  {
    label: 'chemicals',
    parent: '20000209',
    id: '20000217',
    hierarchicalLabel: 'economy, business and finance>economic sector>chemicals'
  },
  {
    label: 'biotechnology business',
    parent: '20000217',
    id: '20000218',
    hierarchicalLabel: 'economy, business and finance>economic sector>chemicals>biotechnology business'
  },
  {
    label: 'fertiliser',
    parent: '20000217',
    id: '20000219',
    hierarchicalLabel: 'economy, business and finance>economic sector>chemicals>fertiliser'
  },
  {
    label: 'health and beauty product',
    parent: '20000217',
    id: '20000220',
    hierarchicalLabel: 'economy, business and finance>economic sector>chemicals>health and beauty product'
  },
  {
    label: 'inorganic chemical',
    parent: '20000217',
    id: '20000221',
    hierarchicalLabel: 'economy, business and finance>economic sector>chemicals>inorganic chemical'
  },
  {
    label: 'organic chemical',
    parent: '20000217',
    id: '20000222',
    hierarchicalLabel: 'economy, business and finance>economic sector>chemicals>organic chemical'
  },
  {
    label: 'pharmaceutical',
    parent: '20000217',
    id: '20000223',
    hierarchicalLabel: 'economy, business and finance>economic sector>chemicals>pharmaceutical'
  },
  {
    label: 'synthetic and plastic chemicals',
    parent: '20000217',
    id: '20000224',
    hierarchicalLabel: 'economy, business and finance>economic sector>chemicals>synthetic and plastic chemicals'
  },
  {
    label: 'computing and information technology',
    parent: '20000209',
    id: '20000225',
    hierarchicalLabel: 'economy, business and finance>economic sector>computing and information technology'
  },
  {
    label: 'hardware',
    parent: '20000225',
    id: '20000226',
    hierarchicalLabel: 'economy, business and finance>economic sector>computing and information technology>hardware'
  },
  {
    label: 'computer networking',
    parent: '20000225',
    id: '20000227',
    hierarchicalLabel: 'economy, business and finance>economic sector>computing and information technology>computer networking'
  },
  {
    label: 'satellite technology',
    parent: '20000225',
    id: '20000228',
    hierarchicalLabel: 'economy, business and finance>economic sector>computing and information technology>satellite technology'
  },
  {
    label: 'computer security',
    parent: '20000225',
    id: '20000229',
    hierarchicalLabel: 'economy, business and finance>economic sector>computing and information technology>computer security'
  },
  {
    label: 'semiconductors and active components',
    parent: '20000225',
    id: '20000230',
    hierarchicalLabel:
      'economy, business and finance>economic sector>computing and information technology>semiconductors and active components'
  },
  {
    label: 'software',
    parent: '20000225',
    id: '20000231',
    hierarchicalLabel: 'economy, business and finance>economic sector>computing and information technology>software'
  },
  {
    label: 'telecommunication equipment',
    parent: '20000225',
    id: '20000232',
    hierarchicalLabel: 'economy, business and finance>economic sector>computing and information technology>telecommunication equipment'
  },
  {
    label: 'telecommunication service',
    parent: '20000225',
    id: '20000233',
    hierarchicalLabel: 'economy, business and finance>economic sector>computing and information technology>telecommunication service'
  },
  {
    label: 'wireless technology',
    parent: '20000225',
    id: '20000234',
    hierarchicalLabel: 'economy, business and finance>economic sector>computing and information technology>wireless technology'
  },
  {
    label: 'Internet of Things',
    parent: '20000225',
    id: '20001161',
    hierarchicalLabel: 'economy, business and finance>economic sector>computing and information technology>Internet of Things'
  },
  {
    label: 'construction and property',
    parent: '20000209',
    id: '20000235',
    hierarchicalLabel: 'economy, business and finance>economic sector>construction and property'
  },
  {
    label: 'design and engineering',
    parent: '20000235',
    id: '20000236',
    hierarchicalLabel: 'economy, business and finance>economic sector>construction and property>design and engineering'
  },
  {
    label: 'farms',
    parent: '20000235',
    id: '20000237',
    hierarchicalLabel: 'economy, business and finance>economic sector>construction and property>farms'
  },
  {
    label: 'heavy construction',
    parent: '20000235',
    id: '20000238',
    hierarchicalLabel: 'economy, business and finance>economic sector>construction and property>heavy construction'
  },
  {
    label: 'house building',
    parent: '20000235',
    id: '20000239',
    hierarchicalLabel: 'economy, business and finance>economic sector>construction and property>house building'
  },
  {
    label: 'land price',
    parent: '20000235',
    id: '20000240',
    hierarchicalLabel: 'economy, business and finance>economic sector>construction and property>land price'
  },
  {
    label: 'real estate',
    parent: '20000235',
    id: '20000241',
    hierarchicalLabel: 'economy, business and finance>economic sector>construction and property>real estate'
  },
  {
    label: 'renovation',
    parent: '20000235',
    id: '20000242',
    hierarchicalLabel: 'economy, business and finance>economic sector>construction and property>renovation'
  },
  {
    label: 'consumer goods',
    parent: '20000209',
    id: '20000243',
    hierarchicalLabel: 'economy, business and finance>economic sector>consumer goods'
  },
  {
    label: 'beverage',
    parent: '20000243',
    id: '20000244',
    hierarchicalLabel: 'economy, business and finance>economic sector>consumer goods>beverage'
  },
  {
    label: 'clothing',
    parent: '20000243',
    id: '20000245',
    hierarchicalLabel: 'economy, business and finance>economic sector>consumer goods>clothing'
  },
  {
    label: 'department store',
    parent: '20000243',
    id: '20000246',
    hierarchicalLabel: 'economy, business and finance>economic sector>consumer goods>department store'
  },
  {
    label: 'electronic commerce',
    parent: '20000243',
    id: '20000247',
    hierarchicalLabel: 'economy, business and finance>economic sector>consumer goods>electronic commerce'
  },
  {
    label: 'food',
    parent: '20000243',
    id: '20000248',
    hierarchicalLabel: 'economy, business and finance>economic sector>consumer goods>food'
  },
  {
    label: 'luxury good',
    parent: '20000243',
    id: '20000249',
    hierarchicalLabel: 'economy, business and finance>economic sector>consumer goods>luxury good'
  },
  {
    label: 'mail order',
    parent: '20000243',
    id: '20000250',
    hierarchicalLabel: 'economy, business and finance>economic sector>consumer goods>mail order'
  },
  {
    label: 'non-durable good',
    parent: '20000243',
    id: '20000251',
    hierarchicalLabel: 'economy, business and finance>economic sector>consumer goods>non-durable good'
  },
  {
    label: 'retail',
    parent: '20000243',
    id: '20000252',
    hierarchicalLabel: 'economy, business and finance>economic sector>consumer goods>retail'
  },
  {
    label: 'speciality store',
    parent: '20000243',
    id: '20000253',
    hierarchicalLabel: 'economy, business and finance>economic sector>consumer goods>speciality store'
  },
  {
    label: 'toy',
    parent: '20000243',
    id: '20000254',
    hierarchicalLabel: 'economy, business and finance>economic sector>consumer goods>toy'
  },
  {
    label: 'wholesale',
    parent: '20000243',
    id: '20000255',
    hierarchicalLabel: 'economy, business and finance>economic sector>consumer goods>wholesale'
  },
  {
    label: 'energy and resource',
    parent: '20000209',
    id: '20000256',
    hierarchicalLabel: 'economy, business and finance>economic sector>energy and resource'
  },
  {
    label: 'alternative energy',
    parent: '20000256',
    id: '20000257',
    hierarchicalLabel: 'economy, business and finance>economic sector>energy and resource>alternative energy'
  },
  {
    label: 'coal',
    parent: '20000256',
    id: '20000258',
    hierarchicalLabel: 'economy, business and finance>economic sector>energy and resource>coal'
  },
  {
    label: 'diesel fuel',
    parent: '20000256',
    id: '20000259',
    hierarchicalLabel: 'economy, business and finance>economic sector>energy and resource>diesel fuel'
  },
  {
    label: 'electricity production and distribution',
    parent: '20000256',
    id: '20000260',
    hierarchicalLabel: 'economy, business and finance>economic sector>energy and resource>electricity production and distribution'
  },
  {
    label: 'energy industry',
    parent: '20000256',
    id: '20000261',
    hierarchicalLabel: 'economy, business and finance>economic sector>energy and resource>energy industry'
  },
  {
    label: 'kerosene/paraffin',
    parent: '20000256',
    id: '20000262',
    hierarchicalLabel: 'economy, business and finance>economic sector>energy and resource>kerosene/paraffin'
  },
  {
    label: 'natural gas',
    parent: '20000256',
    id: '20000263',
    hierarchicalLabel: 'economy, business and finance>economic sector>energy and resource>natural gas'
  },
  {
    label: 'nuclear power',
    parent: '20000256',
    id: '20000265',
    hierarchicalLabel: 'economy, business and finance>economic sector>energy and resource>nuclear power'
  },
  {
    label: 'oil and gas - downstream activities',
    parent: '20000256',
    id: '20000266',
    hierarchicalLabel: 'economy, business and finance>economic sector>energy and resource>oil and gas - downstream activities'
  },
  {
    label: 'oil and gas - upstream activities',
    parent: '20000256',
    id: '20000267',
    hierarchicalLabel: 'economy, business and finance>economic sector>energy and resource>oil and gas - upstream activities'
  },
  {
    label: 'petrol',
    parent: '20000256',
    id: '20000268',
    hierarchicalLabel: 'economy, business and finance>economic sector>energy and resource>petrol'
  },
  {
    label: 'waste management and pollution control',
    parent: '20000256',
    id: '20000269',
    hierarchicalLabel: 'economy, business and finance>economic sector>energy and resource>waste management and pollution control'
  },
  {
    label: 'water supply',
    parent: '20000256',
    id: '20000270',
    hierarchicalLabel: 'economy, business and finance>economic sector>energy and resource>water supply'
  },
  {
    label: 'financial and business service',
    parent: '20000209',
    id: '20000271',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service'
  },
  {
    label: 'accountancy and auditing',
    parent: '20000271',
    id: '20000272',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>accountancy and auditing'
  },
  {
    label: 'auction service',
    parent: '20000271',
    id: '20000273',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>auction service'
  },
  {
    label: 'banking',
    parent: '20000271',
    id: '20000274',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>banking'
  },
  {
    label: 'consultancy service',
    parent: '20000271',
    id: '20000275',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>consultancy service'
  },
  {
    label: 'employment agency',
    parent: '20000271',
    id: '20000276',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>employment agency'
  },
  {
    label: 'funeral parlour and crematorium',
    parent: '20000271',
    id: '20000277',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>funeral parlour and crematorium'
  },
  {
    label: 'healthcare provider',
    parent: '20000271',
    id: '20000278',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>healthcare provider'
  },
  {
    label: 'insurance',
    parent: '20000271',
    id: '20000279',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>insurance'
  },
  {
    label: 'investment service',
    parent: '20000271',
    id: '20000280',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>investment service'
  },
  {
    label: 'janitorial service',
    parent: '20000271',
    id: '20000281',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>janitorial service'
  },
  {
    label: 'legal service',
    parent: '20000271',
    id: '20000282',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>legal service'
  },
  {
    label: 'market research',
    parent: '20000271',
    id: '20000283',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>market research'
  },
  {
    label: 'market trend',
    parent: '20000271',
    id: '20000284',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>market trend'
  },
  {
    label: 'personal finance',
    parent: '20000271',
    id: '20000285',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>personal finance'
  },
  {
    label: 'personal income',
    parent: '20000271',
    id: '20000286',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>personal income'
  },
  {
    label: 'personal investing',
    parent: '20000271',
    id: '20000287',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>personal investing'
  },
  {
    label: 'personal service',
    parent: '20000271',
    id: '20000288',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>personal service'
  },
  {
    label: 'printing/promotional service',
    parent: '20000271',
    id: '20000289',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>printing/promotional service'
  },
  {
    label: 'rental service',
    parent: '20000271',
    id: '20000290',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>rental service'
  },
  {
    label: 'shipping service',
    parent: '20000271',
    id: '20000291',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>shipping service'
  },
  {
    label: 'stock broking',
    parent: '20000271',
    id: '20000292',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>stock broking'
  },
  {
    label: 'wedding service',
    parent: '20000271',
    id: '20000293',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>wedding service'
  },
  {
    label: 'trade fair',
    parent: '20000271',
    id: '20001136',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>trade fair'
  },
  {
    label: 'asset management',
    parent: '20000271',
    id: '20001162',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>asset management'
  },
  {
    label: 'client relationship management',
    parent: '20000271',
    id: '20001163',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>client relationship management'
  },
  {
    label: 'payment service',
    parent: '20000271',
    id: '20001164',
    hierarchicalLabel: 'economy, business and finance>economic sector>financial and business service>payment service'
  },
  {
    label: 'manufacturing and engineering',
    parent: '20000209',
    id: '20000294',
    hierarchicalLabel: 'economy, business and finance>economic sector>manufacturing and engineering'
  },
  {
    label: 'aerospace',
    parent: '20000294',
    id: '20000295',
    hierarchicalLabel: 'economy, business and finance>economic sector>manufacturing and engineering>aerospace'
  },
  {
    label: 'automotive equipment',
    parent: '20000294',
    id: '20000296',
    hierarchicalLabel: 'economy, business and finance>economic sector>manufacturing and engineering>automotive equipment'
  },
  {
    label: 'defence equipment',
    parent: '20000294',
    id: '20000297',
    hierarchicalLabel: 'economy, business and finance>economic sector>manufacturing and engineering>defence equipment'
  },
  {
    label: 'electrical appliance',
    parent: '20000294',
    id: '20000298',
    hierarchicalLabel: 'economy, business and finance>economic sector>manufacturing and engineering>electrical appliance'
  },
  {
    label: 'heavy engineering',
    parent: '20000294',
    id: '20000299',
    hierarchicalLabel: 'economy, business and finance>economic sector>manufacturing and engineering>heavy engineering'
  },
  {
    label: 'industrial component',
    parent: '20000294',
    id: '20000300',
    hierarchicalLabel: 'economy, business and finance>economic sector>manufacturing and engineering>industrial component'
  },
  {
    label: 'instrument engineering',
    parent: '20000294',
    id: '20000301',
    hierarchicalLabel: 'economy, business and finance>economic sector>manufacturing and engineering>instrument engineering'
  },
  {
    label: 'machine manufacturing',
    parent: '20000294',
    id: '20000302',
    hierarchicalLabel: 'economy, business and finance>economic sector>manufacturing and engineering>machine manufacturing'
  },
  {
    label: 'shipbuilding',
    parent: '20000294',
    id: '20000303',
    hierarchicalLabel: 'economy, business and finance>economic sector>manufacturing and engineering>shipbuilding'
  },
  {
    label: 'capital goods',
    parent: '20000294',
    id: '20001165',
    hierarchicalLabel: 'economy, business and finance>economic sector>manufacturing and engineering>capital goods'
  },
  {
    label: 'railway manufacturing',
    parent: '20000294',
    id: '20001166',
    hierarchicalLabel: 'economy, business and finance>economic sector>manufacturing and engineering>railway manufacturing'
  },
  {
    label: 'media',
    parent: '20000209',
    id: '20000304',
    hierarchicalLabel: 'economy, business and finance>economic sector>media'
  },
  {
    label: 'advertising',
    parent: '20000304',
    id: '20000305',
    hierarchicalLabel: 'economy, business and finance>economic sector>media>advertising'
  },
  {
    label: 'book industry',
    parent: '20000304',
    id: '20000306',
    hierarchicalLabel: 'economy, business and finance>economic sector>media>book industry'
  },
  {
    label: 'cinema industry',
    parent: '20000304',
    id: '20000307',
    hierarchicalLabel: 'economy, business and finance>economic sector>media>cinema industry'
  },
  {
    label: 'music industry',
    parent: '20000304',
    id: '20000308',
    hierarchicalLabel: 'economy, business and finance>economic sector>media>music industry'
  },
  {
    label: 'news agency',
    parent: '20000304',
    id: '20000309',
    hierarchicalLabel: 'economy, business and finance>economic sector>media>news agency'
  },
  {
    label: 'newspaper and magazine',
    parent: '20000304',
    id: '20000310',
    hierarchicalLabel: 'economy, business and finance>economic sector>media>newspaper and magazine'
  },
  {
    label: 'online media',
    parent: '20000304',
    id: '20000311',
    hierarchicalLabel: 'economy, business and finance>economic sector>media>online media'
  },
  {
    label: 'public relations',
    parent: '20000304',
    id: '20000312',
    hierarchicalLabel: 'economy, business and finance>economic sector>media>public relations'
  },
  {
    label: 'radio industry',
    parent: '20000304',
    id: '20000313',
    hierarchicalLabel: 'economy, business and finance>economic sector>media>radio industry'
  },
  {
    label: 'satellite and cable service',
    parent: '20000304',
    id: '20000314',
    hierarchicalLabel: 'economy, business and finance>economic sector>media>satellite and cable service'
  },
  {
    label: 'television industry',
    parent: '20000304',
    id: '20000315',
    hierarchicalLabel: 'economy, business and finance>economic sector>media>television industry'
  },
  {
    label: 'metal and mineral',
    parent: '20000209',
    id: '20000316',
    hierarchicalLabel: 'economy, business and finance>economic sector>metal and mineral'
  },
  {
    label: 'building material',
    parent: '20000316',
    id: '20000317',
    hierarchicalLabel: 'economy, business and finance>economic sector>metal and mineral>building material'
  },
  {
    label: 'gold and precious material',
    parent: '20000316',
    id: '20000318',
    hierarchicalLabel: 'economy, business and finance>economic sector>metal and mineral>gold and precious material'
  },
  {
    label: 'iron and steel',
    parent: '20000316',
    id: '20000319',
    hierarchicalLabel: 'economy, business and finance>economic sector>metal and mineral>iron and steel'
  },
  {
    label: 'mining',
    parent: '20000316',
    id: '20000320',
    hierarchicalLabel: 'economy, business and finance>economic sector>metal and mineral>mining'
  },
  {
    label: 'non ferrous metal',
    parent: '20000316',
    id: '20000321',
    hierarchicalLabel: 'economy, business and finance>economic sector>metal and mineral>non ferrous metal'
  },
  {
    label: 'process industry',
    parent: '20000209',
    id: '20000322',
    hierarchicalLabel: 'economy, business and finance>economic sector>process industry'
  },
  {
    label: 'distiller and brewer',
    parent: '20000322',
    id: '20000323',
    hierarchicalLabel: 'economy, business and finance>economic sector>process industry>distiller and brewer'
  },
  {
    label: 'food industry',
    parent: '20000322',
    id: '20000324',
    hierarchicalLabel: 'economy, business and finance>economic sector>process industry>food industry'
  },
  {
    label: 'furnishings and furniture',
    parent: '20000322',
    id: '20000325',
    hierarchicalLabel: 'economy, business and finance>economic sector>process industry>furnishings and furniture'
  },
  {
    label: 'paper and packaging product',
    parent: '20000322',
    id: '20000326',
    hierarchicalLabel: 'economy, business and finance>economic sector>process industry>paper and packaging product'
  },
  {
    label: 'rubber product',
    parent: '20000322',
    id: '20000327',
    hierarchicalLabel: 'economy, business and finance>economic sector>process industry>rubber product'
  },
  {
    label: 'soft drinks',
    parent: '20000322',
    id: '20000328',
    hierarchicalLabel: 'economy, business and finance>economic sector>process industry>soft drinks'
  },
  {
    label: 'textile and clothing',
    parent: '20000322',
    id: '20000329',
    hierarchicalLabel: 'economy, business and finance>economic sector>process industry>textile and clothing'
  },
  {
    label: 'tobacco',
    parent: '20000322',
    id: '20000330',
    hierarchicalLabel: 'economy, business and finance>economic sector>process industry>tobacco'
  },
  {
    label: 'medical equipment',
    parent: '20000322',
    id: '20001167',
    hierarchicalLabel: 'economy, business and finance>economic sector>process industry>medical equipment'
  },
  {
    label: 'pet product and service',
    parent: '20000322',
    id: '20001168',
    hierarchicalLabel: 'economy, business and finance>economic sector>process industry>pet product and service'
  },
  {
    label: 'e-cigarette',
    parent: '20000322',
    id: '20001169',
    hierarchicalLabel: 'economy, business and finance>economic sector>process industry>e-cigarette'
  },
  {
    label: 'tourism and leisure',
    parent: '20000209',
    id: '20000331',
    hierarchicalLabel: 'economy, business and finance>economic sector>tourism and leisure'
  },
  {
    label: 'casino and gambling',
    parent: '20000331',
    id: '20000332',
    hierarchicalLabel: 'economy, business and finance>economic sector>tourism and leisure>casino and gambling'
  },
  {
    label: 'hotel and accommodation',
    parent: '20000331',
    id: '20000333',
    hierarchicalLabel: 'economy, business and finance>economic sector>tourism and leisure>hotel and accommodation'
  },
  {
    label: 'recreational and sporting goods',
    parent: '20000331',
    id: '20000334',
    hierarchicalLabel: 'economy, business and finance>economic sector>tourism and leisure>recreational and sporting goods'
  },
  {
    label: 'restaurant and catering',
    parent: '20000331',
    id: '20000335',
    hierarchicalLabel: 'economy, business and finance>economic sector>tourism and leisure>restaurant and catering'
  },
  {
    label: 'tour operator',
    parent: '20000331',
    id: '20000336',
    hierarchicalLabel: 'economy, business and finance>economic sector>tourism and leisure>tour operator'
  },
  {
    label: 'transport',
    parent: '20000209',
    id: '20000337',
    hierarchicalLabel: 'economy, business and finance>economic sector>transport'
  },
  {
    label: 'air transport',
    parent: '20000337',
    id: '20000338',
    hierarchicalLabel: 'economy, business and finance>economic sector>transport>air transport'
  },
  {
    label: 'railway transport',
    parent: '20000337',
    id: '20000340',
    hierarchicalLabel: 'economy, business and finance>economic sector>transport>railway transport'
  },
  {
    label: 'road transport',
    parent: '20000337',
    id: '20000341',
    hierarchicalLabel: 'economy, business and finance>economic sector>transport>road transport'
  },
  {
    label: 'traffic',
    parent: '20000337',
    id: '20000342',
    hierarchicalLabel: 'economy, business and finance>economic sector>transport>traffic'
  },
  {
    label: 'waterway and maritime transport',
    parent: '20000337',
    id: '20000343',
    hierarchicalLabel: 'economy, business and finance>economic sector>transport>waterway and maritime transport'
  },
  {
    label: 'crafts industry',
    parent: '20000209',
    id: '20001160',
    hierarchicalLabel: 'economy, business and finance>economic sector>crafts industry'
  },
  {
    label: 'logistics',
    parent: '20000209',
    id: '20001170',
    hierarchicalLabel: 'economy, business and finance>economic sector>logistics'
  },
  {
    label: 'economy',
    parent: '04000000',
    id: '20000344',
    hierarchicalLabel: 'economy, business and finance>economy'
  },
  {
    label: 'economic policy',
    parent: '20000344',
    id: '20000345',
    hierarchicalLabel: 'economy, business and finance>economy>economic policy'
  },
  {
    label: 'nationalisation',
    parent: '20000345',
    id: '20000623',
    hierarchicalLabel: 'economy, business and finance>economy>economic policy>nationalisation'
  },
  {
    label: 'privatisation',
    parent: '20000345',
    id: '20000624',
    hierarchicalLabel: 'economy, business and finance>economy>economic policy>privatisation'
  },
  {
    label: 'state-owned enterprise',
    parent: '20000345',
    id: '20000625',
    hierarchicalLabel: 'economy, business and finance>economy>economic policy>state-owned enterprise'
  },
  {
    label: 'macro economics',
    parent: '20000344',
    id: '20000346',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics'
  },
  {
    label: 'bonds',
    parent: '20000346',
    id: '20000347',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>bonds'
  },
  {
    label: 'budgets and budgeting',
    parent: '20000346',
    id: '20000348',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>budgets and budgeting'
  },
  {
    label: 'business enterprise',
    parent: '20000346',
    id: '20000349',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>business enterprise'
  },
  {
    label: 'entrepreneurship',
    parent: '20000349',
    id: '20001158',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>business enterprise>entrepreneurship'
  },
  {
    label: 'small and medium enterprise',
    parent: '20000349',
    id: '20001172',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>business enterprise>small and medium enterprise'
  },
  {
    label: 'central bank',
    parent: '20000346',
    id: '20000350',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>central bank'
  },
  {
    label: 'consumers',
    parent: '20000346',
    id: '20000351',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>consumers'
  },
  {
    label: 'consumer confidence',
    parent: '20000351',
    id: '20000352',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>consumers>consumer confidence'
  },
  {
    label: 'consumer issue',
    parent: '20000351',
    id: '20000353',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>consumers>consumer issue'
  },
  {
    label: 'credit and debt',
    parent: '20000346',
    id: '20000354',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>credit and debt'
  },
  {
    label: 'currency value',
    parent: '20000346',
    id: '20000355',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>currency value'
  },
  {
    label: 'deflation',
    parent: '20000346',
    id: '20000356',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>deflation'
  },
  {
    label: 'economic growth',
    parent: '20000346',
    id: '20000357',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>economic growth'
  },
  {
    label: 'economic indicator',
    parent: '20000346',
    id: '20000358',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>economic indicator'
  },
  {
    label: 'gross domestic product',
    parent: '20000358',
    id: '20000359',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>economic indicator>gross domestic product'
  },
  {
    label: 'industrial production',
    parent: '20000358',
    id: '20000360',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>economic indicator>industrial production'
  },
  {
    label: 'inventories',
    parent: '20000358',
    id: '20000361',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>economic indicator>inventories'
  },
  {
    label: 'productivity',
    parent: '20000358',
    id: '20000362',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>economic indicator>productivity'
  },
  {
    label: 'economic organisation',
    parent: '20000346',
    id: '20000363',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>economic organisation'
  },
  {
    label: 'emerging market',
    parent: '20000346',
    id: '20000364',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>emerging market'
  },
  {
    label: 'employment statistics',
    parent: '20000346',
    id: '20000365',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>employment statistics'
  },
  {
    label: 'exports',
    parent: '20000346',
    id: '20000366',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>exports'
  },
  {
    label: 'government aid',
    parent: '20000346',
    id: '20000367',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>government aid'
  },
  {
    label: 'government debt',
    parent: '20000346',
    id: '20000368',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>government debt'
  },
  {
    label: 'imports',
    parent: '20000346',
    id: '20000369',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>imports'
  },
  {
    label: 'inflation',
    parent: '20000346',
    id: '20000370',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>inflation'
  },
  {
    label: 'interest rate',
    parent: '20000346',
    id: '20000371',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>interest rate'
  },
  {
    label: 'international economic institution',
    parent: '20000346',
    id: '20000372',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>international economic institution'
  },
  {
    label: 'international trade',
    parent: '20000346',
    id: '20000373',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>international trade'
  },
  {
    label: 'trade agreements',
    parent: '20000373',
    id: '20000374',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>international trade>trade agreements'
  },
  {
    label: 'trade balance',
    parent: '20000373',
    id: '20000375',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>international trade>trade balance'
  },
  {
    label: 'trade dispute',
    parent: '20000373',
    id: '20000376',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>international trade>trade dispute'
  },
  {
    label: 'trade policy',
    parent: '20000373',
    id: '20000377',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>international trade>trade policy'
  },
  {
    label: 'investments',
    parent: '20000346',
    id: '20000378',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>investments'
  },
  {
    label: 'money and monetary policy',
    parent: '20000346',
    id: '20000379',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>money and monetary policy'
  },
  {
    label: 'mortgage',
    parent: '20000346',
    id: '20000380',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>mortgage'
  },
  {
    label: 'mutual funds',
    parent: '20000346',
    id: '20000381',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>mutual funds'
  },
  {
    label: 'prices',
    parent: '20000346',
    id: '20000382',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>prices'
  },
  {
    label: 'recession',
    parent: '20000346',
    id: '20000383',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>recession'
  },
  {
    label: 'tariff',
    parent: '20000346',
    id: '20000384',
    hierarchicalLabel: 'economy, business and finance>economy>macro economics>tariff'
  },
  {
    label: 'sharing economy',
    parent: '20000344',
    id: '20001171',
    hierarchicalLabel: 'economy, business and finance>economy>sharing economy'
  },
  {
    label: 'market and exchange',
    parent: '04000000',
    id: '20000385',
    hierarchicalLabel: 'economy, business and finance>market and exchange'
  },
  {
    label: 'commodity market',
    parent: '20000385',
    id: '20000386',
    hierarchicalLabel: 'economy, business and finance>market and exchange>commodity market'
  },
  {
    label: 'energy market',
    parent: '20000386',
    id: '20000387',
    hierarchicalLabel: 'economy, business and finance>market and exchange>commodity market>energy market'
  },
  {
    label: 'metal',
    parent: '20000386',
    id: '20000388',
    hierarchicalLabel: 'economy, business and finance>market and exchange>commodity market>metal'
  },
  {
    label: 'soft commodity',
    parent: '20000386',
    id: '20000389',
    hierarchicalLabel: 'economy, business and finance>market and exchange>commodity market>soft commodity'
  },
  {
    label: 'debt market',
    parent: '20000385',
    id: '20000390',
    hierarchicalLabel: 'economy, business and finance>market and exchange>debt market'
  },
  {
    label: 'foreign exchange market',
    parent: '20000385',
    id: '20000391',
    hierarchicalLabel: 'economy, business and finance>market and exchange>foreign exchange market'
  },
  {
    label: 'loan market',
    parent: '20000385',
    id: '20000392',
    hierarchicalLabel: 'economy, business and finance>market and exchange>loan market'
  },
  {
    label: 'loans',
    parent: '20000392',
    id: '20000393',
    hierarchicalLabel: 'economy, business and finance>market and exchange>loan market>loans'
  },
  {
    label: 'securities',
    parent: '20000385',
    id: '20000394',
    hierarchicalLabel: 'economy, business and finance>market and exchange>securities'
  },
  {
    label: 'derivative securities',
    parent: '20000394',
    id: '20000395',
    hierarchicalLabel: 'economy, business and finance>market and exchange>securities>derivative securities'
  },
  {
    label: 'stocks',
    parent: '20000385',
    id: '20000396',
    hierarchicalLabel: 'economy, business and finance>market and exchange>stocks'
  },
  {
    label: 'stock recommendation',
    parent: '20000396',
    id: '20001137',
    hierarchicalLabel: 'economy, business and finance>market and exchange>stocks>stock recommendation'
  },
  {
    label: 'buy recommendation',
    parent: '20001137',
    id: '20001138',
    hierarchicalLabel: 'economy, business and finance>market and exchange>stocks>stock recommendation>buy recommendation'
  },
  {
    label: 'hold recommendation',
    parent: '20001137',
    id: '20001139',
    hierarchicalLabel: 'economy, business and finance>market and exchange>stocks>stock recommendation>hold recommendation'
  },
  {
    label: 'sell recommendation',
    parent: '20001137',
    id: '20001140',
    hierarchicalLabel: 'economy, business and finance>market and exchange>stocks>stock recommendation>sell recommendation'
  },
  {
    label: 'hot stock',
    parent: '20000396',
    id: '20001141',
    hierarchicalLabel: 'economy, business and finance>market and exchange>stocks>hot stock'
  },
  {
    label: 'education',
    parent: null,
    id: '05000000',
    hierarchicalLabel: 'education'
  },
  {
    label: 'parent organisation',
    parent: '05000000',
    id: '20000398',
    hierarchicalLabel: 'education>parent organisation'
  },
  {
    label: 'religious education',
    parent: '05000000',
    id: '20000399',
    hierarchicalLabel: 'education>religious education'
  },
  {
    label: 'school',
    parent: '05000000',
    id: '20000400',
    hierarchicalLabel: 'education>school'
  },
  {
    label: 'elementary schools',
    parent: '20000400',
    id: '20000401',
    hierarchicalLabel: 'education>school>elementary schools'
  },
  {
    label: 'further education',
    parent: '20000400',
    id: '20000402',
    hierarchicalLabel: 'education>school>further education'
  },
  {
    label: 'adult education',
    parent: '20000402',
    id: '20000403',
    hierarchicalLabel: 'education>school>further education>adult education'
  },
  {
    label: 'high schools',
    parent: '20000400',
    id: '20000404',
    hierarchicalLabel: 'education>school>high schools'
  },
  {
    label: 'higher education',
    parent: '20000400',
    id: '20000405',
    hierarchicalLabel: 'education>school>higher education'
  },
  {
    label: 'college',
    parent: '20000405',
    id: '20000406',
    hierarchicalLabel: 'education>school>higher education>college'
  },
  {
    label: 'university',
    parent: '20000405',
    id: '20000407',
    hierarchicalLabel: 'education>school>higher education>university'
  },
  {
    label: 'middle schools',
    parent: '20000400',
    id: '20000408',
    hierarchicalLabel: 'education>school>middle schools'
  },
  {
    label: 'preschool',
    parent: '20000400',
    id: '20000409',
    hierarchicalLabel: 'education>school>preschool'
  },
  {
    label: 'social learning',
    parent: '05000000',
    id: '20000410',
    hierarchicalLabel: 'education>social learning'
  },
  {
    label: 'teaching and learning',
    parent: '05000000',
    id: '20000411',
    hierarchicalLabel: 'education>teaching and learning'
  },
  {
    label: 'curriculum',
    parent: '20000411',
    id: '20000412',
    hierarchicalLabel: 'education>teaching and learning>curriculum'
  },
  {
    label: 'examination',
    parent: '20000411',
    id: '20000413',
    hierarchicalLabel: 'education>teaching and learning>examination'
  },
  {
    label: 'entrance examination',
    parent: '20000413',
    id: '20000414',
    hierarchicalLabel: 'education>teaching and learning>examination>entrance examination'
  },
  {
    label: 'students',
    parent: '20000411',
    id: '20000415',
    hierarchicalLabel: 'education>teaching and learning>students'
  },
  {
    label: 'teachers',
    parent: '20000411',
    id: '20000416',
    hierarchicalLabel: 'education>teaching and learning>teachers'
  },
  {
    label: 'environment',
    parent: null,
    id: '06000000',
    hierarchicalLabel: 'environment'
  },
  {
    label: 'climate change',
    parent: '06000000',
    id: '20000418',
    hierarchicalLabel: 'environment>climate change'
  },
  {
    label: 'global warming',
    parent: '20000418',
    id: '20000419',
    hierarchicalLabel: 'environment>climate change>global warming'
  },
  {
    label: 'conservation',
    parent: '06000000',
    id: '20000420',
    hierarchicalLabel: 'environment>conservation'
  },
  {
    label: 'energy saving',
    parent: '20000420',
    id: '20000421',
    hierarchicalLabel: 'environment>conservation>energy saving'
  },
  {
    label: 'parks',
    parent: '20000420',
    id: '20000422',
    hierarchicalLabel: 'environment>conservation>parks'
  },
  {
    label: 'environmental politics',
    parent: '06000000',
    id: '20000423',
    hierarchicalLabel: 'environment>environmental politics'
  },
  {
    label: 'environmental pollution',
    parent: '06000000',
    id: '20000424',
    hierarchicalLabel: 'environment>environmental pollution'
  },
  {
    label: 'air pollution',
    parent: '20000424',
    id: '20000425',
    hierarchicalLabel: 'environment>environmental pollution>air pollution'
  },
  {
    label: 'environmental cleanup',
    parent: '20000424',
    id: '20000426',
    hierarchicalLabel: 'environment>environmental pollution>environmental cleanup'
  },
  {
    label: 'hazardous materials',
    parent: '20000424',
    id: '20000427',
    hierarchicalLabel: 'environment>environmental pollution>hazardous materials'
  },
  {
    label: 'waste materials',
    parent: '20000424',
    id: '20000428',
    hierarchicalLabel: 'environment>environmental pollution>waste materials'
  },
  {
    label: 'water pollution',
    parent: '20000424',
    id: '20000429',
    hierarchicalLabel: 'environment>environmental pollution>water pollution'
  },
  {
    label: 'natural resources',
    parent: '06000000',
    id: '20000430',
    hierarchicalLabel: 'environment>natural resources'
  },
  {
    label: 'energy resources',
    parent: '20000430',
    id: '20000431',
    hierarchicalLabel: 'environment>natural resources>energy resources'
  },
  {
    label: 'land resources',
    parent: '20000430',
    id: '20000432',
    hierarchicalLabel: 'environment>natural resources>land resources'
  },
  {
    label: 'forests',
    parent: '20000432',
    id: '20000433',
    hierarchicalLabel: 'environment>natural resources>land resources>forests'
  },
  {
    label: 'mountains',
    parent: '20000432',
    id: '20000434',
    hierarchicalLabel: 'environment>natural resources>land resources>mountains'
  },
  {
    label: 'population growth',
    parent: '20000430',
    id: '20000435',
    hierarchicalLabel: 'environment>natural resources>population growth'
  },
  {
    label: 'renewable energy',
    parent: '20000430',
    id: '20000436',
    hierarchicalLabel: 'environment>natural resources>renewable energy'
  },
  {
    label: 'water',
    parent: '20000430',
    id: '20000437',
    hierarchicalLabel: 'environment>natural resources>water'
  },
  {
    label: 'oceans',
    parent: '20000437',
    id: '20000438',
    hierarchicalLabel: 'environment>natural resources>water>oceans'
  },
  {
    label: 'rivers',
    parent: '20000437',
    id: '20000439',
    hierarchicalLabel: 'environment>natural resources>water>rivers'
  },
  {
    label: 'wetlands',
    parent: '20000437',
    id: '20000440',
    hierarchicalLabel: 'environment>natural resources>water>wetlands'
  },
  {
    label: 'nature',
    parent: '06000000',
    id: '20000441',
    hierarchicalLabel: 'environment>nature'
  },
  {
    label: 'ecosystem',
    parent: '20000441',
    id: '20000442',
    hierarchicalLabel: 'environment>nature>ecosystem'
  },
  {
    label: 'endangered species',
    parent: '20000441',
    id: '20000443',
    hierarchicalLabel: 'environment>nature>endangered species'
  },
  {
    label: 'invasive species',
    parent: '20000441',
    id: '20000444',
    hierarchicalLabel: 'environment>nature>invasive species'
  },
  {
    label: 'health',
    parent: null,
    id: '07000000',
    hierarchicalLabel: 'health'
  },
  {
    label: 'diseases and conditions',
    parent: '07000000',
    id: '20000446',
    hierarchicalLabel: 'health>diseases and conditions'
  },
  {
    label: 'cancer',
    parent: '20000446',
    id: '20000447',
    hierarchicalLabel: 'health>diseases and conditions>cancer'
  },
  {
    label: 'communicable disease',
    parent: '20000446',
    id: '20000448',
    hierarchicalLabel: 'health>diseases and conditions>communicable disease'
  },
  {
    label: 'epidemic',
    parent: '20000448',
    id: '20000449',
    hierarchicalLabel: 'health>diseases and conditions>communicable disease>epidemic'
  },
  {
    label: 'plague (disease)',
    parent: '20000449',
    id: '20000450',
    hierarchicalLabel: 'health>diseases and conditions>communicable disease>epidemic>plague (disease)'
  },
  {
    label: 'virus disease',
    parent: '20000448',
    id: '20000451',
    hierarchicalLabel: 'health>diseases and conditions>communicable disease>virus disease'
  },
  {
    label: 'AIDS',
    parent: '20000451',
    id: '20000452',
    hierarchicalLabel: 'health>diseases and conditions>communicable disease>virus disease>AIDS'
  },
  {
    label: 'retrovirus',
    parent: '20000451',
    id: '20000453',
    hierarchicalLabel: 'health>diseases and conditions>communicable disease>virus disease>retrovirus'
  },
  {
    label: 'heart disease',
    parent: '20000446',
    id: '20000454',
    hierarchicalLabel: 'health>diseases and conditions>heart disease'
  },
  {
    label: 'illness',
    parent: '20000446',
    id: '20000455',
    hierarchicalLabel: 'health>diseases and conditions>illness'
  },
  {
    label: 'injury',
    parent: '20000446',
    id: '20000456',
    hierarchicalLabel: 'health>diseases and conditions>injury'
  },
  {
    label: 'medical conditions',
    parent: '20000446',
    id: '20000457',
    hierarchicalLabel: 'health>diseases and conditions>medical conditions'
  },
  {
    label: 'mental and behavioural disorder',
    parent: '20000446',
    id: '20000458',
    hierarchicalLabel: 'health>diseases and conditions>mental and behavioural disorder'
  },
  {
    label: 'eating disorder',
    parent: '20000458',
    id: '20000459',
    hierarchicalLabel: 'health>diseases and conditions>mental and behavioural disorder>eating disorder'
  },
  {
    label: 'obesity',
    parent: '20000446',
    id: '20000460',
    hierarchicalLabel: 'health>diseases and conditions>obesity'
  },
  {
    label: 'health facility',
    parent: '07000000',
    id: '20000461',
    hierarchicalLabel: 'health>health facility'
  },
  {
    label: 'hospital and clinic',
    parent: '20000461',
    id: '20000462',
    hierarchicalLabel: 'health>health facility>hospital and clinic'
  },
  {
    label: 'health organisations',
    parent: '07000000',
    id: '20000463',
    hierarchicalLabel: 'health>health organisations'
  },
  {
    label: 'health treatment',
    parent: '07000000',
    id: '20000464',
    hierarchicalLabel: 'health>health treatment'
  },
  {
    label: 'diet',
    parent: '20000464',
    id: '20000465',
    hierarchicalLabel: 'health>health treatment>diet'
  },
  {
    label: 'dietary supplements',
    parent: '20000465',
    id: '20000466',
    hierarchicalLabel: 'health>health treatment>diet>dietary supplements'
  },
  {
    label: 'medical drugs',
    parent: '20000464',
    id: '20000467',
    hierarchicalLabel: 'health>health treatment>medical drugs'
  },
  {
    label: 'prescription drugs',
    parent: '20000467',
    id: '20000468',
    hierarchicalLabel: 'health>health treatment>medical drugs>prescription drugs'
  },
  {
    label: 'medical procedure/test',
    parent: '20000464',
    id: '20000469',
    hierarchicalLabel: 'health>health treatment>medical procedure/test'
  },
  {
    label: 'medicine',
    parent: '20000464',
    id: '20000470',
    hierarchicalLabel: 'health>health treatment>medicine'
  },
  {
    label: 'herbal medicine',
    parent: '20000470',
    id: '20000471',
    hierarchicalLabel: 'health>health treatment>medicine>herbal medicine'
  },
  {
    label: 'holistic medicine',
    parent: '20000470',
    id: '20000472',
    hierarchicalLabel: 'health>health treatment>medicine>holistic medicine'
  },
  {
    label: 'traditional Chinese medicine',
    parent: '20000470',
    id: '20000473',
    hierarchicalLabel: 'health>health treatment>medicine>traditional Chinese medicine'
  },
  {
    label: 'western medicine',
    parent: '20000470',
    id: '20000474',
    hierarchicalLabel: 'health>health treatment>medicine>western medicine'
  },
  {
    label: 'physical fitness',
    parent: '20000464',
    id: '20000475',
    hierarchicalLabel: 'health>health treatment>physical fitness'
  },
  {
    label: 'preventative medicine',
    parent: '20000464',
    id: '20000476',
    hierarchicalLabel: 'health>health treatment>preventative medicine'
  },
  {
    label: 'vaccines',
    parent: '20000476',
    id: '20000477',
    hierarchicalLabel: 'health>health treatment>preventative medicine>vaccines'
  },
  {
    label: 'therapy',
    parent: '20000464',
    id: '20000478',
    hierarchicalLabel: 'health>health treatment>therapy'
  },
  {
    label: 'healthcare policy',
    parent: '07000000',
    id: '20000479',
    hierarchicalLabel: 'health>healthcare policy'
  },
  {
    label: 'government health care',
    parent: '20000479',
    id: '20000480',
    hierarchicalLabel: 'health>healthcare policy>government health care'
  },
  {
    label: 'Medicaid',
    parent: '20000480',
    id: '20000481',
    hierarchicalLabel: 'health>healthcare policy>government health care>Medicaid'
  },
  {
    label: 'Medicare',
    parent: '20000480',
    id: '20000482',
    hierarchicalLabel: 'health>healthcare policy>government health care>Medicare'
  },
  {
    label: 'health insurance',
    parent: '20000479',
    id: '20000483',
    hierarchicalLabel: 'health>healthcare policy>health insurance'
  },
  {
    label: 'private health care',
    parent: '20000479',
    id: '20000484',
    hierarchicalLabel: 'health>healthcare policy>private health care'
  },
  {
    label: 'medical profession',
    parent: '07000000',
    id: '20000485',
    hierarchicalLabel: 'health>medical profession'
  },
  {
    label: 'medical service',
    parent: '20000485',
    id: '20000486',
    hierarchicalLabel: 'health>medical profession>medical service'
  },
  {
    label: 'medical specialisation',
    parent: '20000485',
    id: '20000487',
    hierarchicalLabel: 'health>medical profession>medical specialisation'
  },
  {
    label: 'geriatric medicine',
    parent: '20000487',
    id: '20000488',
    hierarchicalLabel: 'health>medical profession>medical specialisation>geriatric medicine'
  },
  {
    label: 'obstetrics/gynaecology',
    parent: '20000487',
    id: '20000489',
    hierarchicalLabel: 'health>medical profession>medical specialisation>obstetrics/gynaecology'
  },
  {
    label: 'paediatrics',
    parent: '20000487',
    id: '20000490',
    hierarchicalLabel: 'health>medical profession>medical specialisation>paediatrics'
  },
  {
    label: 'reproductive medicine',
    parent: '20000487',
    id: '20000491',
    hierarchicalLabel: 'health>medical profession>medical specialisation>reproductive medicine'
  },
  {
    label: 'medical staff',
    parent: '20000485',
    id: '20000492',
    hierarchicalLabel: 'health>medical profession>medical staff'
  },
  {
    label: 'non-human diseases',
    parent: '07000000',
    id: '20000493',
    hierarchicalLabel: 'health>non-human diseases'
  },
  {
    label: 'animal disease',
    parent: '20000493',
    id: '20000494',
    hierarchicalLabel: 'health>non-human diseases>animal disease'
  },
  {
    label: 'plant disease',
    parent: '20000493',
    id: '20000495',
    hierarchicalLabel: 'health>non-human diseases>plant disease'
  },
  {
    label: 'human interest',
    parent: null,
    id: '08000000',
    hierarchicalLabel: 'human interest'
  },
  {
    label: 'accomplishment',
    parent: '08000000',
    id: '20000497',
    hierarchicalLabel: 'human interest>accomplishment'
  },
  {
    label: 'award and prize',
    parent: '20000497',
    id: '20000498',
    hierarchicalLabel: 'human interest>accomplishment>award and prize'
  },
  {
    label: 'records and achievements',
    parent: '20000497',
    id: '20000499',
    hierarchicalLabel: 'human interest>accomplishment>records and achievements'
  },
  {
    label: 'animal',
    parent: '08000000',
    id: '20000500',
    hierarchicalLabel: 'human interest>animal'
  },
  {
    label: 'ceremony',
    parent: '08000000',
    id: '20000501',
    hierarchicalLabel: 'human interest>ceremony'
  },
  {
    label: 'people',
    parent: '08000000',
    id: '20000502',
    hierarchicalLabel: 'human interest>people'
  },
  {
    label: 'human mishap',
    parent: '20000502',
    id: '20000503',
    hierarchicalLabel: 'human interest>people>human mishap'
  },
  {
    label: 'high-society',
    parent: '20000502',
    id: '20000504',
    hierarchicalLabel: 'human interest>people>high-society'
  },
  {
    label: 'celebrity',
    parent: '20000504',
    id: '20000505',
    hierarchicalLabel: 'human interest>people>high-society>celebrity'
  },
  {
    label: 'imperial and royal matters',
    parent: '20000504',
    id: '20000506',
    hierarchicalLabel: 'human interest>people>high-society>imperial and royal matters'
  },
  {
    label: 'plant',
    parent: '08000000',
    id: '20000507',
    hierarchicalLabel: 'human interest>plant'
  },
  {
    label: 'labour',
    parent: null,
    id: '09000000',
    hierarchicalLabel: 'labour'
  },
  {
    label: 'employment',
    parent: '09000000',
    id: '20000509',
    hierarchicalLabel: 'labour>employment'
  },
  {
    label: 'commuting',
    parent: '20000509',
    id: '20000339',
    hierarchicalLabel: 'labour>employment>commuting'
  },
  {
    label: 'apprentices',
    parent: '20000509',
    id: '20000510',
    hierarchicalLabel: 'labour>employment>apprentices'
  },
  {
    label: 'child labour',
    parent: '20000509',
    id: '20000511',
    hierarchicalLabel: 'labour>employment>child labour'
  },
  {
    label: 'employee',
    parent: '20000509',
    id: '20000512',
    hierarchicalLabel: 'labour>employment>employee'
  },
  {
    label: 'employer',
    parent: '20000509',
    id: '20000513',
    hierarchicalLabel: 'labour>employment>employer'
  },
  {
    label: 'employment training',
    parent: '20000509',
    id: '20000514',
    hierarchicalLabel: 'labour>employment>employment training'
  },
  {
    label: 'advanced training',
    parent: '20000514',
    id: '20000515',
    hierarchicalLabel: 'labour>employment>employment training>advanced training'
  },
  {
    label: 'retraining',
    parent: '20000514',
    id: '20000516',
    hierarchicalLabel: 'labour>employment>employment training>retraining'
  },
  {
    label: 'occupations',
    parent: '20000509',
    id: '20000517',
    hierarchicalLabel: 'labour>employment>occupations'
  },
  {
    label: 'wage and benefit',
    parent: '20000509',
    id: '20000518',
    hierarchicalLabel: 'labour>employment>wage and benefit'
  },
  {
    label: 'employee benefits',
    parent: '20000518',
    id: '20000519',
    hierarchicalLabel: 'labour>employment>wage and benefit>employee benefits'
  },
  {
    label: 'social security',
    parent: '20000518',
    id: '20000520',
    hierarchicalLabel: 'labour>employment>wage and benefit>social security'
  },
  {
    label: 'employment legislation',
    parent: '09000000',
    id: '20000521',
    hierarchicalLabel: 'labour>employment legislation'
  },
  {
    label: 'health and safety at work',
    parent: '20000521',
    id: '20000522',
    hierarchicalLabel: 'labour>employment legislation>health and safety at work'
  },
  {
    label: 'labour market',
    parent: '09000000',
    id: '20000523',
    hierarchicalLabel: 'labour>labour market'
  },
  {
    label: 'labour relations',
    parent: '09000000',
    id: '20000524',
    hierarchicalLabel: 'labour>labour relations'
  },
  {
    label: 'collective contract',
    parent: '20000524',
    id: '20000525',
    hierarchicalLabel: 'labour>labour relations>collective contract'
  },
  {
    label: 'contract issue-healthcare',
    parent: '20000525',
    id: '20000526',
    hierarchicalLabel: 'labour>labour relations>collective contract>contract issue-healthcare'
  },
  {
    label: 'contract issue-wages',
    parent: '20000525',
    id: '20000527',
    hierarchicalLabel: 'labour>labour relations>collective contract>contract issue-wages'
  },
  {
    label: 'contract issue-work rules',
    parent: '20000525',
    id: '20000528',
    hierarchicalLabel: 'labour>labour relations>collective contract>contract issue-work rules'
  },
  {
    label: 'labour dispute',
    parent: '20000524',
    id: '20000529',
    hierarchicalLabel: 'labour>labour relations>labour dispute'
  },
  {
    label: 'strike',
    parent: '20000529',
    id: '20000530',
    hierarchicalLabel: 'labour>labour relations>labour dispute>strike'
  },
  {
    label: 'retirement',
    parent: '09000000',
    id: '20000531',
    hierarchicalLabel: 'labour>retirement'
  },
  {
    label: 'pension',
    parent: '20000531',
    id: '20000532',
    hierarchicalLabel: 'labour>retirement>pension'
  },
  {
    label: 'unemployment',
    parent: '09000000',
    id: '20000533',
    hierarchicalLabel: 'labour>unemployment'
  },
  {
    label: 'job layoffs',
    parent: '20000533',
    id: '20000534',
    hierarchicalLabel: 'labour>unemployment>job layoffs'
  },
  {
    label: 'unemployment benefits',
    parent: '20000533',
    id: '20000535',
    hierarchicalLabel: 'labour>unemployment>unemployment benefits'
  },
  {
    label: 'unions',
    parent: '09000000',
    id: '20000536',
    hierarchicalLabel: 'labour>unions'
  },
  {
    label: 'lifestyle and leisure',
    parent: null,
    id: '10000000',
    hierarchicalLabel: 'lifestyle and leisure'
  },
  {
    label: 'leisure',
    parent: '10000000',
    id: '20000538',
    hierarchicalLabel: 'lifestyle and leisure>leisure'
  },
  {
    label: 'club and association',
    parent: '20000538',
    id: '20000539',
    hierarchicalLabel: 'lifestyle and leisure>leisure>club and association'
  },
  {
    label: 'game',
    parent: '20000538',
    id: '20000540',
    hierarchicalLabel: 'lifestyle and leisure>leisure>game'
  },
  {
    label: 'board game',
    parent: '20000540',
    id: '20000541',
    hierarchicalLabel: 'lifestyle and leisure>leisure>game>board game'
  },
  {
    label: 'card game',
    parent: '20000540',
    id: '20000542',
    hierarchicalLabel: 'lifestyle and leisure>leisure>game>card game'
  },
  {
    label: "children's game",
    parent: '20000540',
    id: '20000543',
    hierarchicalLabel: "lifestyle and leisure>leisure>game>children's game"
  },
  {
    label: 'dice game',
    parent: '20000540',
    id: '20000544',
    hierarchicalLabel: 'lifestyle and leisure>leisure>game>dice game'
  },
  {
    label: 'outdoor game',
    parent: '20000540',
    id: '20000545',
    hierarchicalLabel: 'lifestyle and leisure>leisure>game>outdoor game'
  },
  {
    label: 'puzzle',
    parent: '20000540',
    id: '20000546',
    hierarchicalLabel: 'lifestyle and leisure>leisure>game>puzzle'
  },
  {
    label: 'tile game',
    parent: '20000540',
    id: '20000547',
    hierarchicalLabel: 'lifestyle and leisure>leisure>game>tile game'
  },
  {
    label: 'video game',
    parent: '20000540',
    id: '20000548',
    hierarchicalLabel: 'lifestyle and leisure>leisure>game>video game'
  },
  {
    label: 'gaming and lottery',
    parent: '20000538',
    id: '20000549',
    hierarchicalLabel: 'lifestyle and leisure>leisure>gaming and lottery'
  },
  {
    label: 'hobby',
    parent: '20000538',
    id: '20000550',
    hierarchicalLabel: 'lifestyle and leisure>leisure>hobby'
  },
  {
    label: 'holiday',
    parent: '20000538',
    id: '20000551',
    hierarchicalLabel: 'lifestyle and leisure>leisure>holiday'
  },
  {
    label: 'public holiday',
    parent: '20000551',
    id: '20000552',
    hierarchicalLabel: 'lifestyle and leisure>leisure>holiday>public holiday'
  },
  {
    label: 'leisure venue',
    parent: '20000538',
    id: '20000553',
    hierarchicalLabel: 'lifestyle and leisure>leisure>leisure venue'
  },
  {
    label: 'amusement park',
    parent: '20000553',
    id: '20000554',
    hierarchicalLabel: 'lifestyle and leisure>leisure>leisure venue>amusement park'
  },
  {
    label: 'bar',
    parent: '20000553',
    id: '20000555',
    hierarchicalLabel: 'lifestyle and leisure>leisure>leisure venue>bar'
  },
  {
    label: 'cafe',
    parent: '20000553',
    id: '20000556',
    hierarchicalLabel: 'lifestyle and leisure>leisure>leisure venue>cafe'
  },
  {
    label: 'nightclub',
    parent: '20000553',
    id: '20000557',
    hierarchicalLabel: 'lifestyle and leisure>leisure>leisure venue>nightclub'
  },
  {
    label: 'restaurant',
    parent: '20000553',
    id: '20000558',
    hierarchicalLabel: 'lifestyle and leisure>leisure>leisure venue>restaurant'
  },
  {
    label: 'sports facilities',
    parent: '20000553',
    id: '20000559',
    hierarchicalLabel: 'lifestyle and leisure>leisure>leisure venue>sports facilities'
  },
  {
    label: 'recreational activities',
    parent: '20000538',
    id: '20000560',
    hierarchicalLabel: 'lifestyle and leisure>leisure>recreational activities'
  },
  {
    label: 'fishing',
    parent: '20000560',
    id: '20000561',
    hierarchicalLabel: 'lifestyle and leisure>leisure>recreational activities>fishing'
  },
  {
    label: 'hunting',
    parent: '20000560',
    id: '20000562',
    hierarchicalLabel: 'lifestyle and leisure>leisure>recreational activities>hunting'
  },
  {
    label: 'mountaineering',
    parent: '20000560',
    id: '20001142',
    hierarchicalLabel: 'lifestyle and leisure>leisure>recreational activities>mountaineering'
  },
  {
    label: 'travel',
    parent: '20000538',
    id: '20000563',
    hierarchicalLabel: 'lifestyle and leisure>leisure>travel'
  },
  {
    label: 'tourism',
    parent: '20000563',
    id: '20000564',
    hierarchicalLabel: 'lifestyle and leisure>leisure>travel>tourism'
  },
  {
    label: 'lifestyle',
    parent: '10000000',
    id: '20000565',
    hierarchicalLabel: 'lifestyle and leisure>lifestyle'
  },
  {
    label: 'automobile enthusiasm',
    parent: '20000565',
    id: '20000566',
    hierarchicalLabel: 'lifestyle and leisure>lifestyle>automobile enthusiasm'
  },
  {
    label: 'bicycle enthusiasm',
    parent: '20000565',
    id: '20000567',
    hierarchicalLabel: 'lifestyle and leisure>lifestyle>bicycle enthusiasm'
  },
  {
    label: 'food and drink',
    parent: '20000565',
    id: '20000568',
    hierarchicalLabel: 'lifestyle and leisure>lifestyle>food and drink'
  },
  {
    label: 'organic food',
    parent: '20000568',
    id: '20000569',
    hierarchicalLabel: 'lifestyle and leisure>lifestyle>food and drink>organic food'
  },
  {
    label: 'house and home',
    parent: '20000565',
    id: '20000570',
    hierarchicalLabel: 'lifestyle and leisure>lifestyle>house and home'
  },
  {
    label: 'motorbike enthusiasm',
    parent: '20000565',
    id: '20000571',
    hierarchicalLabel: 'lifestyle and leisure>lifestyle>motorbike enthusiasm'
  },
  {
    label: 'trend',
    parent: '20000565',
    id: '20000572',
    hierarchicalLabel: 'lifestyle and leisure>lifestyle>trend'
  },
  {
    label: 'party',
    parent: '20000565',
    id: '20001143',
    hierarchicalLabel: 'lifestyle and leisure>lifestyle>party'
  },
  {
    label: 'politics',
    parent: null,
    id: '11000000',
    hierarchicalLabel: 'politics'
  },
  {
    label: 'election',
    parent: '11000000',
    id: '20000574',
    hierarchicalLabel: 'politics>election'
  },
  {
    label: 'citizens initiative and recall',
    parent: '20000574',
    id: '20000575',
    hierarchicalLabel: 'politics>election>citizens initiative and recall'
  },
  {
    label: 'electoral system',
    parent: '20000574',
    id: '20000576',
    hierarchicalLabel: 'politics>election>electoral system'
  },
  {
    label: 'intergovernmental elections',
    parent: '20000574',
    id: '20000577',
    hierarchicalLabel: 'politics>election>intergovernmental elections'
  },
  {
    label: 'local elections',
    parent: '20000574',
    id: '20000578',
    hierarchicalLabel: 'politics>election>local elections'
  },
  {
    label: 'national elections',
    parent: '20000574',
    id: '20000579',
    hierarchicalLabel: 'politics>election>national elections'
  },
  {
    label: 'political campaigns',
    parent: '20000574',
    id: '20000580',
    hierarchicalLabel: 'politics>election>political campaigns'
  },
  {
    label: 'campaign finance',
    parent: '20000580',
    id: '20000581',
    hierarchicalLabel: 'politics>election>political campaigns>campaign finance'
  },
  {
    label: 'political candidates',
    parent: '20000574',
    id: '20000582',
    hierarchicalLabel: 'politics>election>political candidates'
  },
  {
    label: 'primary elections',
    parent: '20000574',
    id: '20000583',
    hierarchicalLabel: 'politics>election>primary elections'
  },
  {
    label: 'referenda',
    parent: '20000574',
    id: '20000584',
    hierarchicalLabel: 'politics>election>referenda'
  },
  {
    label: 'regional elections',
    parent: '20000574',
    id: '20000585',
    hierarchicalLabel: 'politics>election>regional elections'
  },
  {
    label: 'voting',
    parent: '20000574',
    id: '20000586',
    hierarchicalLabel: 'politics>election>voting'
  },
  {
    label: 'fundamental rights',
    parent: '11000000',
    id: '20000587',
    hierarchicalLabel: 'politics>fundamental rights'
  },
  {
    label: 'civil rights',
    parent: '20000587',
    id: '20000120',
    hierarchicalLabel: 'politics>fundamental rights>civil rights'
  },
  {
    label: 'censorship',
    parent: '20000587',
    id: '20000588',
    hierarchicalLabel: 'politics>fundamental rights>censorship'
  },
  {
    label: 'freedom of religion',
    parent: '20000587',
    id: '20000590',
    hierarchicalLabel: 'politics>fundamental rights>freedom of religion'
  },
  {
    label: 'freedom of the press',
    parent: '20000587',
    id: '20000591',
    hierarchicalLabel: 'politics>fundamental rights>freedom of the press'
  },
  {
    label: 'human rights',
    parent: '20000587',
    id: '20000592',
    hierarchicalLabel: 'politics>fundamental rights>human rights'
  },
  {
    label: 'government',
    parent: '11000000',
    id: '20000593',
    hierarchicalLabel: 'politics>government'
  },
  {
    label: 'civil and public service',
    parent: '20000593',
    id: '20000594',
    hierarchicalLabel: 'politics>government>civil and public service'
  },
  {
    label: 'public employees',
    parent: '20000594',
    id: '20000595',
    hierarchicalLabel: 'politics>government>civil and public service>public employees'
  },
  {
    label: 'public officials',
    parent: '20000594',
    id: '20000596',
    hierarchicalLabel: 'politics>government>civil and public service>public officials'
  },
  {
    label: 'civilian service',
    parent: '20000594',
    id: '20001144',
    hierarchicalLabel: 'politics>government>civil and public service>civilian service'
  },
  {
    label: 'constitution (law)',
    parent: '20000593',
    id: '20000597',
    hierarchicalLabel: 'politics>government>constitution (law)'
  },
  {
    label: 'defence',
    parent: '20000593',
    id: '20000598',
    hierarchicalLabel: 'politics>government>defence'
  },
  {
    label: 'armed forces',
    parent: '20000598',
    id: '20000599',
    hierarchicalLabel: 'politics>government>defence>armed forces'
  },
  {
    label: 'veterans affairs',
    parent: '20000599',
    id: '20000600',
    hierarchicalLabel: 'politics>government>defence>armed forces>veterans affairs'
  },
  {
    label: 'military service',
    parent: '20000599',
    id: '20001145',
    hierarchicalLabel: 'politics>government>defence>armed forces>military service'
  },
  {
    label: 'military equipment',
    parent: '20000598',
    id: '20000601',
    hierarchicalLabel: 'politics>government>defence>military equipment'
  },
  {
    label: 'military weaponry',
    parent: '20000601',
    id: '20000602',
    hierarchicalLabel: 'politics>government>defence>military equipment>military weaponry'
  },
  {
    label: 'security measures (defence)',
    parent: '20000598',
    id: '20000603',
    hierarchicalLabel: 'politics>government>defence>security measures (defence)'
  },
  {
    label: 'national security',
    parent: '20000603',
    id: '20000604',
    hierarchicalLabel: 'politics>government>defence>security measures (defence)>national security'
  },
  {
    label: 'espionage and intelligence',
    parent: '20000593',
    id: '20000605',
    hierarchicalLabel: 'politics>government>espionage and intelligence'
  },
  {
    label: 'executive (government)',
    parent: '20000593',
    id: '20000606',
    hierarchicalLabel: 'politics>government>executive (government)'
  },
  {
    label: 'government budget',
    parent: '20000593',
    id: '20000607',
    hierarchicalLabel: 'politics>government>government budget'
  },
  {
    label: 'public finance',
    parent: '20000607',
    id: '20000608',
    hierarchicalLabel: 'politics>government>government budget>public finance'
  },
  {
    label: 'government department',
    parent: '20000593',
    id: '20000609',
    hierarchicalLabel: 'politics>government>government department'
  },
  {
    label: 'heads of state',
    parent: '20000593',
    id: '20000610',
    hierarchicalLabel: 'politics>government>heads of state'
  },
  {
    label: 'impeachment',
    parent: '20000593',
    id: '20000611',
    hierarchicalLabel: 'politics>government>impeachment'
  },
  {
    label: 'local government and authority',
    parent: '20000593',
    id: '20000612',
    hierarchicalLabel: 'politics>government>local government and authority'
  },
  {
    label: 'ministers (government)',
    parent: '20000593',
    id: '20000613',
    hierarchicalLabel: 'politics>government>ministers (government)'
  },
  {
    label: 'national government',
    parent: '20000593',
    id: '20000614',
    hierarchicalLabel: 'politics>government>national government'
  },
  {
    label: 'parliament',
    parent: '20000593',
    id: '20000615',
    hierarchicalLabel: 'politics>government>parliament'
  },
  {
    label: 'lower house (parliament)',
    parent: '20000615',
    id: '20000616',
    hierarchicalLabel: 'politics>government>parliament>lower house (parliament)'
  },
  {
    label: 'upper house (parliament)',
    parent: '20000615',
    id: '20000617',
    hierarchicalLabel: 'politics>government>parliament>upper house (parliament)'
  },
  {
    label: 'regional government and authority',
    parent: '20000593',
    id: '20000618',
    hierarchicalLabel: 'politics>government>regional government and authority'
  },
  {
    label: 'regulatory authority',
    parent: '20000593',
    id: '20001173',
    hierarchicalLabel: 'politics>government>regulatory authority'
  },
  {
    label: 'government policy',
    parent: '11000000',
    id: '20000621',
    hierarchicalLabel: 'politics>government policy'
  },
  {
    label: 'economic policy',
    parent: '20000621',
    id: '20000345',
    hierarchicalLabel: 'politics>government policy>economic policy'
  },
  {
    label: 'nationalisation',
    parent: '20000345',
    id: '20000623',
    hierarchicalLabel: 'economy, business and finance>economy>economic policy>nationalisation'
  },
  {
    label: 'privatisation',
    parent: '20000345',
    id: '20000624',
    hierarchicalLabel: 'economy, business and finance>economy>economic policy>privatisation'
  },
  {
    label: 'state-owned enterprise',
    parent: '20000345',
    id: '20000625',
    hierarchicalLabel: 'economy, business and finance>economy>economic policy>state-owned enterprise'
  },
  {
    label: 'safety of citizens',
    parent: '20000621',
    id: '20000619',
    hierarchicalLabel: 'politics>government policy>safety of citizens'
  },
  {
    label: 'taxation',
    parent: '20000621',
    id: '20000620',
    hierarchicalLabel: 'politics>government policy>taxation'
  },
  {
    label: 'interior policy',
    parent: '20000621',
    id: '20000626',
    hierarchicalLabel: 'politics>government policy>interior policy'
  },
  {
    label: 'data protection policy',
    parent: '20000626',
    id: '20000627',
    hierarchicalLabel: 'politics>government policy>interior policy>data protection policy'
  },
  {
    label: 'housing and urban planning policy',
    parent: '20000626',
    id: '20000628',
    hierarchicalLabel: 'politics>government policy>interior policy>housing and urban planning policy'
  },
  {
    label: 'policy towards indigenous people',
    parent: '20000626',
    id: '20000629',
    hierarchicalLabel: 'politics>government policy>interior policy>policy towards indigenous people'
  },
  {
    label: 'pension and welfare policy',
    parent: '20000626',
    id: '20000630',
    hierarchicalLabel: 'politics>government policy>interior policy>pension and welfare policy'
  },
  {
    label: 'personal data collection policy',
    parent: '20000626',
    id: '20000631',
    hierarchicalLabel: 'politics>government policy>interior policy>personal data collection policy'
  },
  {
    label: 'personal weapon control policy',
    parent: '20000626',
    id: '20000632',
    hierarchicalLabel: 'politics>government policy>interior policy>personal weapon control policy'
  },
  {
    label: 'planning inquiries',
    parent: '20000626',
    id: '20000633',
    hierarchicalLabel: 'politics>government policy>interior policy>planning inquiries'
  },
  {
    label: 'integration policy',
    parent: '20000626',
    id: '20001146',
    hierarchicalLabel: 'politics>government policy>interior policy>integration policy'
  },
  {
    label: 'regional development policy',
    parent: '20000626',
    id: '20001174',
    hierarchicalLabel: 'politics>government policy>interior policy>regional development policy'
  },
  {
    label: 'migration of people',
    parent: '20000621',
    id: '20000634',
    hierarchicalLabel: 'politics>government policy>migration of people'
  },
  {
    label: 'nuclear policy',
    parent: '20000621',
    id: '20000635',
    hierarchicalLabel: 'politics>government policy>nuclear policy'
  },
  {
    label: 'regulatory of industry',
    parent: '20000621',
    id: '20000636',
    hierarchicalLabel: 'politics>government policy>regulatory of industry'
  },
  {
    label: 'food and drink regulations',
    parent: '20000636',
    id: '20000637',
    hierarchicalLabel: 'politics>government policy>regulatory of industry>food and drink regulations'
  },
  {
    label: 'cultural policies',
    parent: '20000621',
    id: '20001132',
    hierarchicalLabel: 'politics>government policy>cultural policies'
  },
  {
    label: 'sports policies',
    parent: '20000621',
    id: '20001147',
    hierarchicalLabel: 'politics>government policy>sports policies'
  },
  {
    label: 'international relations',
    parent: '11000000',
    id: '20000638',
    hierarchicalLabel: 'politics>international relations'
  },
  {
    label: 'diplomacy',
    parent: '20000638',
    id: '20000639',
    hierarchicalLabel: 'politics>international relations>diplomacy'
  },
  {
    label: 'summit meetings',
    parent: '20000639',
    id: '20000640',
    hierarchicalLabel: 'politics>international relations>diplomacy>summit meetings'
  },
  {
    label: 'treaty',
    parent: '20000639',
    id: '20000641',
    hierarchicalLabel: 'politics>international relations>diplomacy>treaty'
  },
  {
    label: 'economic sanction',
    parent: '20000638',
    id: '20000642',
    hierarchicalLabel: 'politics>international relations>economic sanction'
  },
  {
    label: 'foreign aid',
    parent: '20000638',
    id: '20000643',
    hierarchicalLabel: 'politics>international relations>foreign aid'
  },
  {
    label: 'international organisation',
    parent: '20000638',
    id: '20000644',
    hierarchicalLabel: 'politics>international relations>international organisation'
  },
  {
    label: 'refugees and internally displaced people',
    parent: '20000638',
    id: '20000645',
    hierarchicalLabel: 'politics>international relations>refugees and internally displaced people'
  },
  {
    label: 'non-governmental organisation',
    parent: '11000000',
    id: '20000646',
    hierarchicalLabel: 'politics>non-governmental organisation'
  },
  {
    label: 'political crisis',
    parent: '11000000',
    id: '20000647',
    hierarchicalLabel: 'politics>political crisis'
  },
  {
    label: 'political dissent',
    parent: '11000000',
    id: '20000648',
    hierarchicalLabel: 'politics>political dissent'
  },
  {
    label: 'political process',
    parent: '11000000',
    id: '20000649',
    hierarchicalLabel: 'politics>political process'
  },
  {
    label: 'lobbying',
    parent: '20000649',
    id: '20000650',
    hierarchicalLabel: 'politics>political process>lobbying'
  },
  {
    label: 'political parties and movements',
    parent: '20000649',
    id: '20000651',
    hierarchicalLabel: 'politics>political process>political parties and movements'
  },
  {
    label: 'political development',
    parent: '20000649',
    id: '20000652',
    hierarchicalLabel: 'politics>political process>political development'
  },
  {
    label: 'political system',
    parent: '20000649',
    id: '20000653',
    hierarchicalLabel: 'politics>political process>political system'
  },
  {
    label: 'democracy',
    parent: '20000653',
    id: '20000654',
    hierarchicalLabel: 'politics>political process>political system>democracy'
  },
  {
    label: 'dictatorship',
    parent: '20000653',
    id: '20000655',
    hierarchicalLabel: 'politics>political process>political system>dictatorship'
  },
  {
    label: 'religion and belief',
    parent: null,
    id: '12000000',
    hierarchicalLabel: 'religion and belief'
  },
  {
    label: 'religious belief',
    parent: '12000000',
    id: '20000657',
    hierarchicalLabel: 'religion and belief>religious belief'
  },
  {
    label: 'Buddhism',
    parent: '20000657',
    id: '20000658',
    hierarchicalLabel: 'religion and belief>religious belief>Buddhism'
  },
  {
    label: 'Christianity',
    parent: '20000657',
    id: '20000659',
    hierarchicalLabel: 'religion and belief>religious belief>Christianity'
  },
  {
    label: 'ecumenism',
    parent: '20000659',
    id: '20000660',
    hierarchicalLabel: 'religion and belief>religious belief>Christianity>ecumenism'
  },
  {
    label: 'Mormon',
    parent: '20000659',
    id: '20000661',
    hierarchicalLabel: 'religion and belief>religious belief>Christianity>Mormon'
  },
  {
    label: 'Old Catholic',
    parent: '20000659',
    id: '20000662',
    hierarchicalLabel: 'religion and belief>religious belief>Christianity>Old Catholic'
  },
  {
    label: 'Orthodoxy',
    parent: '20000659',
    id: '20000663',
    hierarchicalLabel: 'religion and belief>religious belief>Christianity>Orthodoxy'
  },
  {
    label: 'Protestant',
    parent: '20000659',
    id: '20000664',
    hierarchicalLabel: 'religion and belief>religious belief>Christianity>Protestant'
  },
  {
    label: 'Anglican',
    parent: '20000664',
    id: '20000665',
    hierarchicalLabel: 'religion and belief>religious belief>Christianity>Protestant>Anglican'
  },
  {
    label: 'Baptist',
    parent: '20000664',
    id: '20000666',
    hierarchicalLabel: 'religion and belief>religious belief>Christianity>Protestant>Baptist'
  },
  {
    label: 'Lutheran',
    parent: '20000664',
    id: '20000667',
    hierarchicalLabel: 'religion and belief>religious belief>Christianity>Protestant>Lutheran'
  },
  {
    label: 'Mennonite',
    parent: '20000664',
    id: '20000668',
    hierarchicalLabel: 'religion and belief>religious belief>Christianity>Protestant>Mennonite'
  },
  {
    label: 'Methodist',
    parent: '20000664',
    id: '20000669',
    hierarchicalLabel: 'religion and belief>religious belief>Christianity>Protestant>Methodist'
  },
  {
    label: 'Reformed',
    parent: '20000664',
    id: '20000670',
    hierarchicalLabel: 'religion and belief>religious belief>Christianity>Protestant>Reformed'
  },
  {
    label: 'Roman Catholic',
    parent: '20000659',
    id: '20000671',
    hierarchicalLabel: 'religion and belief>religious belief>Christianity>Roman Catholic'
  },
  {
    label: 'concordat',
    parent: '20000671',
    id: '20000672',
    hierarchicalLabel: 'religion and belief>religious belief>Christianity>Roman Catholic>concordat'
  },
  {
    label: 'Confucianism',
    parent: '20000657',
    id: '20000673',
    hierarchicalLabel: 'religion and belief>religious belief>Confucianism'
  },
  {
    label: 'cult and sect',
    parent: '20000657',
    id: '20000674',
    hierarchicalLabel: 'religion and belief>religious belief>cult and sect'
  },
  {
    label: 'Freemasonry',
    parent: '20000657',
    id: '20000675',
    hierarchicalLabel: 'religion and belief>religious belief>Freemasonry'
  },
  {
    label: 'Hinduism',
    parent: '20000657',
    id: '20000676',
    hierarchicalLabel: 'religion and belief>religious belief>Hinduism'
  },
  {
    label: 'Islam',
    parent: '20000657',
    id: '20000677',
    hierarchicalLabel: 'religion and belief>religious belief>Islam'
  },
  {
    label: 'Jainism',
    parent: '20000657',
    id: '20000678',
    hierarchicalLabel: 'religion and belief>religious belief>Jainism'
  },
  {
    label: 'Judaism',
    parent: '20000657',
    id: '20000679',
    hierarchicalLabel: 'religion and belief>religious belief>Judaism'
  },
  {
    label: 'nature religion',
    parent: '20000657',
    id: '20000680',
    hierarchicalLabel: 'religion and belief>religious belief>nature religion'
  },
  {
    label: 'Parsasm',
    parent: '20000657',
    id: '20000681',
    hierarchicalLabel: 'religion and belief>religious belief>Parsasm'
  },
  {
    label: 'Scientology',
    parent: '20000657',
    id: '20000682',
    hierarchicalLabel: 'religion and belief>religious belief>Scientology'
  },
  {
    label: 'Shintoism',
    parent: '20000657',
    id: '20000683',
    hierarchicalLabel: 'religion and belief>religious belief>Shintoism'
  },
  {
    label: 'Sikhism',
    parent: '20000657',
    id: '20000684',
    hierarchicalLabel: 'religion and belief>religious belief>Sikhism'
  },
  {
    label: 'Taoism',
    parent: '20000657',
    id: '20000685',
    hierarchicalLabel: 'religion and belief>religious belief>Taoism'
  },
  {
    label: 'Unificationism',
    parent: '20000657',
    id: '20000686',
    hierarchicalLabel: 'religion and belief>religious belief>Unificationism'
  },
  {
    label: 'interreligious dialogue',
    parent: '12000000',
    id: '20000687',
    hierarchicalLabel: 'religion and belief>interreligious dialogue'
  },
  {
    label: 'religious conflict',
    parent: '12000000',
    id: '20000688',
    hierarchicalLabel: 'religion and belief>religious conflict'
  },
  {
    label: 'religious event',
    parent: '12000000',
    id: '20000689',
    hierarchicalLabel: 'religion and belief>religious event'
  },
  {
    label: 'religious festival or holiday',
    parent: '20000689',
    id: '20000690',
    hierarchicalLabel: 'religion and belief>religious event>religious festival or holiday'
  },
  {
    label: 'Christmas',
    parent: '20000690',
    id: '20000691',
    hierarchicalLabel: 'religion and belief>religious event>religious festival or holiday>Christmas'
  },
  {
    label: 'Easter',
    parent: '20000690',
    id: '20000692',
    hierarchicalLabel: 'religion and belief>religious event>religious festival or holiday>Easter'
  },
  {
    label: 'Pentecost',
    parent: '20000690',
    id: '20000693',
    hierarchicalLabel: 'religion and belief>religious event>religious festival or holiday>Pentecost'
  },
  {
    label: 'Ramadan',
    parent: '20000690',
    id: '20000694',
    hierarchicalLabel: 'religion and belief>religious event>religious festival or holiday>Ramadan'
  },
  {
    label: 'Yom Kippur',
    parent: '20000690',
    id: '20000695',
    hierarchicalLabel: 'religion and belief>religious event>religious festival or holiday>Yom Kippur'
  },
  {
    label: 'religious ritual',
    parent: '20000689',
    id: '20000696',
    hierarchicalLabel: 'religion and belief>religious event>religious ritual'
  },
  {
    label: 'religious facilities',
    parent: '12000000',
    id: '20000697',
    hierarchicalLabel: 'religion and belief>religious facilities'
  },
  {
    label: 'church',
    parent: '20000697',
    id: '20000698',
    hierarchicalLabel: 'religion and belief>religious facilities>church'
  },
  {
    label: 'mosque',
    parent: '20000697',
    id: '20000699',
    hierarchicalLabel: 'religion and belief>religious facilities>mosque'
  },
  {
    label: 'synagogue',
    parent: '20000697',
    id: '20000700',
    hierarchicalLabel: 'religion and belief>religious facilities>synagogue'
  },
  {
    label: 'temple',
    parent: '20000697',
    id: '20000701',
    hierarchicalLabel: 'religion and belief>religious facilities>temple'
  },
  {
    label: 'religious institutions and state relations',
    parent: '12000000',
    id: '20000702',
    hierarchicalLabel: 'religion and belief>religious institutions and state relations'
  },
  {
    label: 'religious leader',
    parent: '12000000',
    id: '20000703',
    hierarchicalLabel: 'religion and belief>religious leader'
  },
  {
    label: 'pope',
    parent: '20000703',
    id: '20000704',
    hierarchicalLabel: 'religion and belief>religious leader>pope'
  },
  {
    label: 'religious text',
    parent: '12000000',
    id: '20000705',
    hierarchicalLabel: 'religion and belief>religious text'
  },
  {
    label: 'Bible',
    parent: '20000705',
    id: '20000706',
    hierarchicalLabel: 'religion and belief>religious text>Bible'
  },
  {
    label: "Qur'an",
    parent: '20000705',
    id: '20000707',
    hierarchicalLabel: "religion and belief>religious text>Qur'an"
  },
  {
    label: 'Torah',
    parent: '20000705',
    id: '20000708',
    hierarchicalLabel: 'religion and belief>religious text>Torah'
  },
  {
    label: 'science and technology',
    parent: null,
    id: '13000000',
    hierarchicalLabel: 'science and technology'
  },
  {
    label: 'biomedical science',
    parent: '13000000',
    id: '20000710',
    hierarchicalLabel: 'science and technology>biomedical science'
  },
  {
    label: 'biotechnology science',
    parent: '20000710',
    id: '20000711',
    hierarchicalLabel: 'science and technology>biomedical science>biotechnology science'
  },
  {
    label: 'dentistry',
    parent: '20000710',
    id: '20000712',
    hierarchicalLabel: 'science and technology>biomedical science>dentistry'
  },
  {
    label: 'pharmacology',
    parent: '20000710',
    id: '20000713',
    hierarchicalLabel: 'science and technology>biomedical science>pharmacology'
  },
  {
    label: 'veterinarian science',
    parent: '20000710',
    id: '20000714',
    hierarchicalLabel: 'science and technology>biomedical science>veterinarian science'
  },
  {
    label: 'mathematics',
    parent: '13000000',
    id: '20000715',
    hierarchicalLabel: 'science and technology>mathematics'
  },
  {
    label: 'mechanical engineering',
    parent: '13000000',
    id: '20000716',
    hierarchicalLabel: 'science and technology>mechanical engineering'
  },
  {
    label: 'natural science',
    parent: '13000000',
    id: '20000717',
    hierarchicalLabel: 'science and technology>natural science'
  },
  {
    label: 'astronomy',
    parent: '20000717',
    id: '20000718',
    hierarchicalLabel: 'science and technology>natural science>astronomy'
  },
  {
    label: 'biology',
    parent: '20000717',
    id: '20000719',
    hierarchicalLabel: 'science and technology>natural science>biology'
  },
  {
    label: 'botany',
    parent: '20000719',
    id: '20000720',
    hierarchicalLabel: 'science and technology>natural science>biology>botany'
  },
  {
    label: 'genetics',
    parent: '20000719',
    id: '20000721',
    hierarchicalLabel: 'science and technology>natural science>biology>genetics'
  },
  {
    label: 'palaeontology',
    parent: '20000719',
    id: '20000722',
    hierarchicalLabel: 'science and technology>natural science>biology>palaeontology'
  },
  {
    label: 'physiology',
    parent: '20000719',
    id: '20000723',
    hierarchicalLabel: 'science and technology>natural science>biology>physiology'
  },
  {
    label: 'zoology',
    parent: '20000719',
    id: '20000724',
    hierarchicalLabel: 'science and technology>natural science>biology>zoology'
  },
  {
    label: 'chemistry',
    parent: '20000717',
    id: '20000725',
    hierarchicalLabel: 'science and technology>natural science>chemistry'
  },
  {
    label: 'cosmology',
    parent: '20000717',
    id: '20000726',
    hierarchicalLabel: 'science and technology>natural science>cosmology'
  },
  {
    label: 'geology',
    parent: '20000717',
    id: '20000727',
    hierarchicalLabel: 'science and technology>natural science>geology'
  },
  {
    label: 'horticulture',
    parent: '20000717',
    id: '20000728',
    hierarchicalLabel: 'science and technology>natural science>horticulture'
  },
  {
    label: 'marine science',
    parent: '20000717',
    id: '20000729',
    hierarchicalLabel: 'science and technology>natural science>marine science'
  },
  {
    label: 'meteorology',
    parent: '20000717',
    id: '20000730',
    hierarchicalLabel: 'science and technology>natural science>meteorology'
  },
  {
    label: 'physics',
    parent: '20000717',
    id: '20000731',
    hierarchicalLabel: 'science and technology>natural science>physics'
  },
  {
    label: 'electromagnetism',
    parent: '20000731',
    id: '20000732',
    hierarchicalLabel: 'science and technology>natural science>physics>electromagnetism'
  },
  {
    label: 'nuclear physics',
    parent: '20000731',
    id: '20000733',
    hierarchicalLabel: 'science and technology>natural science>physics>nuclear physics'
  },
  {
    label: 'particle physics',
    parent: '20000733',
    id: '20000734',
    hierarchicalLabel: 'science and technology>natural science>physics>nuclear physics>particle physics'
  },
  {
    label: 'research',
    parent: '13000000',
    id: '20000735',
    hierarchicalLabel: 'science and technology>research'
  },
  {
    label: 'discovery and innovation',
    parent: '20000735',
    id: '20000736',
    hierarchicalLabel: 'science and technology>research>discovery and innovation'
  },
  {
    label: 'medical research',
    parent: '20000735',
    id: '20000737',
    hierarchicalLabel: 'science and technology>research>medical research'
  },
  {
    label: 'scientific exploration',
    parent: '20000735',
    id: '20000738',
    hierarchicalLabel: 'science and technology>research>scientific exploration'
  },
  {
    label: 'space programme',
    parent: '20000738',
    id: '20000739',
    hierarchicalLabel: 'science and technology>research>scientific exploration>space programme'
  },
  {
    label: 'scientific paper',
    parent: '20000735',
    id: '20000740',
    hierarchicalLabel: 'science and technology>research>scientific paper'
  },
  {
    label: 'scientific institutions',
    parent: '13000000',
    id: '20000741',
    hierarchicalLabel: 'science and technology>scientific institutions'
  },
  {
    label: 'social sciences',
    parent: '13000000',
    id: '20000742',
    hierarchicalLabel: 'science and technology>social sciences'
  },
  {
    label: 'anthropology',
    parent: '20000742',
    id: '20000743',
    hierarchicalLabel: 'science and technology>social sciences>anthropology'
  },
  {
    label: 'archaeology',
    parent: '20000742',
    id: '20000744',
    hierarchicalLabel: 'science and technology>social sciences>archaeology'
  },
  {
    label: 'economics',
    parent: '20000742',
    id: '20000745',
    hierarchicalLabel: 'science and technology>social sciences>economics'
  },
  {
    label: 'geography',
    parent: '20000742',
    id: '20000746',
    hierarchicalLabel: 'science and technology>social sciences>geography'
  },
  {
    label: 'history',
    parent: '20000742',
    id: '20000747',
    hierarchicalLabel: 'science and technology>social sciences>history'
  },
  {
    label: 'information science',
    parent: '20000742',
    id: '20000748',
    hierarchicalLabel: 'science and technology>social sciences>information science'
  },
  {
    label: 'study of law',
    parent: '20000742',
    id: '20000749',
    hierarchicalLabel: 'science and technology>social sciences>study of law'
  },
  {
    label: 'linguistics',
    parent: '20000742',
    id: '20000750',
    hierarchicalLabel: 'science and technology>social sciences>linguistics'
  },
  {
    label: 'philosophy',
    parent: '20000742',
    id: '20000751',
    hierarchicalLabel: 'science and technology>social sciences>philosophy'
  },
  {
    label: 'political science',
    parent: '20000742',
    id: '20000752',
    hierarchicalLabel: 'science and technology>social sciences>political science'
  },
  {
    label: 'psychology',
    parent: '20000742',
    id: '20000753',
    hierarchicalLabel: 'science and technology>social sciences>psychology'
  },
  {
    label: 'sociology',
    parent: '20000742',
    id: '20000754',
    hierarchicalLabel: 'science and technology>social sciences>sociology'
  },
  {
    label: 'scientific standards',
    parent: '13000000',
    id: '20000755',
    hierarchicalLabel: 'science and technology>scientific standards'
  },
  {
    label: 'technology and engineering',
    parent: '13000000',
    id: '20000756',
    hierarchicalLabel: 'science and technology>technology and engineering'
  },
  {
    label: 'aerospace engineering',
    parent: '20000756',
    id: '20000757',
    hierarchicalLabel: 'science and technology>technology and engineering>aerospace engineering'
  },
  {
    label: 'rocketry',
    parent: '20000757',
    id: '20000758',
    hierarchicalLabel: 'science and technology>technology and engineering>aerospace engineering>rocketry'
  },
  {
    label: 'agricultural technology',
    parent: '20000756',
    id: '20000759',
    hierarchicalLabel: 'science and technology>technology and engineering>agricultural technology'
  },
  {
    label: 'civil engineering',
    parent: '20000756',
    id: '20000760',
    hierarchicalLabel: 'science and technology>technology and engineering>civil engineering'
  },
  {
    label: 'electronics',
    parent: '20000756',
    id: '20000761',
    hierarchicalLabel: 'science and technology>technology and engineering>electronics'
  },
  {
    label: 'identification technology',
    parent: '20000756',
    id: '20000762',
    hierarchicalLabel: 'science and technology>technology and engineering>identification technology'
  },
  {
    label: 'IT/computer sciences',
    parent: '20000756',
    id: '20000763',
    hierarchicalLabel: 'science and technology>technology and engineering>IT/computer sciences'
  },
  {
    label: 'material science',
    parent: '20000756',
    id: '20000764',
    hierarchicalLabel: 'science and technology>technology and engineering>material science'
  },
  {
    label: 'micro science',
    parent: '20000756',
    id: '20000765',
    hierarchicalLabel: 'science and technology>technology and engineering>micro science'
  },
  {
    label: 'nanotechnology',
    parent: '20000765',
    id: '20000766',
    hierarchicalLabel: 'science and technology>technology and engineering>micro science>nanotechnology'
  },
  {
    label: 'society',
    parent: null,
    id: '14000000',
    hierarchicalLabel: 'society'
  },
  {
    label: 'communities',
    parent: '14000000',
    id: '20000768',
    hierarchicalLabel: 'society>communities'
  },
  {
    label: 'social networking',
    parent: '20000768',
    id: '20000769',
    hierarchicalLabel: 'society>communities>social networking'
  },
  {
    label: 'demographics',
    parent: '14000000',
    id: '20000770',
    hierarchicalLabel: 'society>demographics'
  },
  {
    label: 'immigration',
    parent: '20000770',
    id: '20000771',
    hierarchicalLabel: 'society>demographics>immigration'
  },
  {
    label: 'emigrants',
    parent: '20000771',
    id: '20000772',
    hierarchicalLabel: 'society>demographics>immigration>emigrants'
  },
  {
    label: 'illegal immigrants',
    parent: '20000771',
    id: '20000773',
    hierarchicalLabel: 'society>demographics>immigration>illegal immigrants'
  },
  {
    label: 'population and census',
    parent: '20000770',
    id: '20000774',
    hierarchicalLabel: 'society>demographics>population and census'
  },
  {
    label: 'discrimination',
    parent: '14000000',
    id: '20000775',
    hierarchicalLabel: 'society>discrimination'
  },
  {
    label: 'ageism',
    parent: '20000775',
    id: '20000776',
    hierarchicalLabel: 'society>discrimination>ageism'
  },
  {
    label: 'racism',
    parent: '20000775',
    id: '20000777',
    hierarchicalLabel: 'society>discrimination>racism'
  },
  {
    label: 'religious discrimination',
    parent: '20000775',
    id: '20000778',
    hierarchicalLabel: 'society>discrimination>religious discrimination'
  },
  {
    label: 'sexism',
    parent: '20000775',
    id: '20000779',
    hierarchicalLabel: 'society>discrimination>sexism'
  },
  {
    label: 'family',
    parent: '14000000',
    id: '20000780',
    hierarchicalLabel: 'society>family'
  },
  {
    label: 'adoption',
    parent: '20000780',
    id: '20000781',
    hierarchicalLabel: 'society>family>adoption'
  },
  {
    label: 'courtship',
    parent: '20000780',
    id: '20000782',
    hierarchicalLabel: 'society>family>courtship'
  },
  {
    label: 'divorce',
    parent: '20000780',
    id: '20000783',
    hierarchicalLabel: 'society>family>divorce'
  },
  {
    label: 'family planning',
    parent: '20000780',
    id: '20000784',
    hierarchicalLabel: 'society>family>family planning'
  },
  {
    label: 'abortion',
    parent: '20000784',
    id: '20000785',
    hierarchicalLabel: 'society>family>family planning>abortion'
  },
  {
    label: 'marriage',
    parent: '20000780',
    id: '20000786',
    hierarchicalLabel: 'society>family>marriage'
  },
  {
    label: 'parent and child',
    parent: '20000780',
    id: '20000787',
    hierarchicalLabel: 'society>family>parent and child'
  },
  {
    label: 'mankind',
    parent: '14000000',
    id: '20000788',
    hierarchicalLabel: 'society>mankind'
  },
  {
    label: 'adults',
    parent: '20000788',
    id: '20000789',
    hierarchicalLabel: 'society>mankind>adults'
  },
  {
    label: 'children',
    parent: '20000788',
    id: '20000790',
    hierarchicalLabel: 'society>mankind>children'
  },
  {
    label: 'disabled',
    parent: '20000788',
    id: '20000791',
    hierarchicalLabel: 'society>mankind>disabled'
  },
  {
    label: 'gays and lesbians',
    parent: '20000788',
    id: '20000792',
    hierarchicalLabel: 'society>mankind>gays and lesbians'
  },
  {
    label: 'gender',
    parent: '20000788',
    id: '20000793',
    hierarchicalLabel: 'society>mankind>gender'
  },
  {
    label: 'infants',
    parent: '20000788',
    id: '20000794',
    hierarchicalLabel: 'society>mankind>infants'
  },
  {
    label: 'national or ethnic minority',
    parent: '20000788',
    id: '20000795',
    hierarchicalLabel: 'society>mankind>national or ethnic minority'
  },
  {
    label: 'nuclear radiation victims',
    parent: '20000788',
    id: '20000796',
    hierarchicalLabel: 'society>mankind>nuclear radiation victims'
  },
  {
    label: 'senior citizens',
    parent: '20000788',
    id: '20000797',
    hierarchicalLabel: 'society>mankind>senior citizens'
  },
  {
    label: 'teenagers',
    parent: '20000788',
    id: '20000798',
    hierarchicalLabel: 'society>mankind>teenagers'
  },
  {
    label: 'social condition',
    parent: '14000000',
    id: '20000799',
    hierarchicalLabel: 'society>social condition'
  },
  {
    label: 'homelessness',
    parent: '20000799',
    id: '20000800',
    hierarchicalLabel: 'society>social condition>homelessness'
  },
  {
    label: 'poverty',
    parent: '20000799',
    id: '20000801',
    hierarchicalLabel: 'society>social condition>poverty'
  },
  {
    label: 'social problem',
    parent: '14000000',
    id: '20000802',
    hierarchicalLabel: 'society>social problem'
  },
  {
    label: 'abusive behaviour',
    parent: '20000802',
    id: '20000803',
    hierarchicalLabel: 'society>social problem>abusive behaviour'
  },
  {
    label: 'addiction',
    parent: '20000802',
    id: '20000804',
    hierarchicalLabel: 'society>social problem>addiction'
  },
  {
    label: 'juvenile delinquency',
    parent: '20000802',
    id: '20000805',
    hierarchicalLabel: 'society>social problem>juvenile delinquency'
  },
  {
    label: 'prostitution',
    parent: '20000802',
    id: '20000806',
    hierarchicalLabel: 'society>social problem>prostitution'
  },
  {
    label: 'slavery',
    parent: '20000802',
    id: '20000807',
    hierarchicalLabel: 'society>social problem>slavery'
  },
  {
    label: 'values',
    parent: '14000000',
    id: '20000808',
    hierarchicalLabel: 'society>values'
  },
  {
    label: 'corrupt practices',
    parent: '20000808',
    id: '20000809',
    hierarchicalLabel: 'society>values>corrupt practices'
  },
  {
    label: 'death and dying',
    parent: '20000808',
    id: '20000810',
    hierarchicalLabel: 'society>values>death and dying'
  },
  {
    label: 'euthanasia',
    parent: '20000810',
    id: '20000811',
    hierarchicalLabel: 'society>values>death and dying>euthanasia'
  },
  {
    label: 'assisted suicide',
    parent: '20000811',
    id: '20000812',
    hierarchicalLabel: 'society>values>death and dying>euthanasia>assisted suicide'
  },
  {
    label: 'suicide',
    parent: '20000810',
    id: '20000813',
    hierarchicalLabel: 'society>values>death and dying>suicide'
  },
  {
    label: 'ethics',
    parent: '20000808',
    id: '20000814',
    hierarchicalLabel: 'society>values>ethics'
  },
  {
    label: 'pornography',
    parent: '20000808',
    id: '20000815',
    hierarchicalLabel: 'society>values>pornography'
  },
  {
    label: 'sexual behaviour',
    parent: '20000808',
    id: '20000816',
    hierarchicalLabel: 'society>values>sexual behaviour'
  },
  {
    label: 'welfare',
    parent: '14000000',
    id: '20000817',
    hierarchicalLabel: 'society>welfare'
  },
  {
    label: 'charity',
    parent: '20000817',
    id: '20000818',
    hierarchicalLabel: 'society>welfare>charity'
  },
  {
    label: 'long term care',
    parent: '20000817',
    id: '20000819',
    hierarchicalLabel: 'society>welfare>long term care'
  },
  {
    label: 'social services',
    parent: '20000817',
    id: '20000820',
    hierarchicalLabel: 'society>welfare>social services'
  },
  {
    label: 'sport',
    parent: null,
    id: '15000000',
    hierarchicalLabel: 'sport'
  },
  {
    label: 'competition discipline',
    parent: '15000000',
    id: '20000822',
    hierarchicalLabel: 'sport>competition discipline'
  },
  {
    label: 'American football',
    parent: '20000822',
    id: '20000823',
    hierarchicalLabel: 'sport>competition discipline>American football'
  },
  {
    label: 'archery',
    parent: '20000822',
    id: '20000824',
    hierarchicalLabel: 'sport>competition discipline>archery'
  },
  {
    label: 'crossbow shooting',
    parent: '20000824',
    id: '20000825',
    hierarchicalLabel: 'sport>competition discipline>archery>crossbow shooting'
  },
  {
    label: 'longbow',
    parent: '20000824',
    id: '20000826',
    hierarchicalLabel: 'sport>competition discipline>archery>longbow'
  },
  {
    label: 'athletics, track and field',
    parent: '20000822',
    id: '20000827',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field'
  },
  {
    label: 'cross country run',
    parent: '20000827',
    id: '20000828',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>cross country run'
  },
  {
    label: 'decathlon',
    parent: '20000827',
    id: '20000829',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>decathlon'
  },
  {
    label: 'discus throw',
    parent: '20000827',
    id: '20000830',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>discus throw'
  },
  {
    label: 'hammer throw',
    parent: '20000827',
    id: '20000831',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>hammer throw'
  },
  {
    label: 'heptathlon',
    parent: '20000827',
    id: '20000832',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>heptathlon'
  },
  {
    label: 'high jump',
    parent: '20000827',
    id: '20000833',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>high jump'
  },
  {
    label: 'hurdles',
    parent: '20000827',
    id: '20000834',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>hurdles'
  },
  {
    label: 'javelin throw',
    parent: '20000827',
    id: '20000835',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>javelin throw'
  },
  {
    label: 'long distance run',
    parent: '20000827',
    id: '20000836',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>long distance run'
  },
  {
    label: 'long jump',
    parent: '20000827',
    id: '20000837',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>long jump'
  },
  {
    label: 'middle distance run',
    parent: '20000827',
    id: '20000838',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>middle distance run'
  },
  {
    label: 'pentathlon',
    parent: '20000827',
    id: '20000839',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>pentathlon'
  },
  {
    label: 'pole vault',
    parent: '20000827',
    id: '20000840',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>pole vault'
  },
  {
    label: 'race walking',
    parent: '20000827',
    id: '20000841',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>race walking'
  },
  {
    label: 'relay run',
    parent: '20000827',
    id: '20000842',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>relay run'
  },
  {
    label: 'shot put',
    parent: '20000827',
    id: '20000843',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>shot put'
  },
  {
    label: 'sprint run',
    parent: '20000827',
    id: '20000844',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>sprint run'
  },
  {
    label: 'triple jump',
    parent: '20000827',
    id: '20000845',
    hierarchicalLabel: 'sport>competition discipline>athletics, track and field>triple jump'
  },
  {
    label: 'Australian rules football',
    parent: '20000822',
    id: '20000846',
    hierarchicalLabel: 'sport>competition discipline>Australian rules football'
  },
  {
    label: 'badminton',
    parent: '20000822',
    id: '20000847',
    hierarchicalLabel: 'sport>competition discipline>badminton'
  },
  {
    label: 'bandy',
    parent: '20000822',
    id: '20000848',
    hierarchicalLabel: 'sport>competition discipline>bandy'
  },
  {
    label: 'baseball',
    parent: '20000822',
    id: '20000849',
    hierarchicalLabel: 'sport>competition discipline>baseball'
  },
  {
    label: 'rubberball baseball',
    parent: '20000849',
    id: '20000850',
    hierarchicalLabel: 'sport>competition discipline>baseball>rubberball baseball'
  },
  {
    label: 'basketball',
    parent: '20000822',
    id: '20000851',
    hierarchicalLabel: 'sport>competition discipline>basketball'
  },
  {
    label: 'biathlon',
    parent: '20000822',
    id: '20000852',
    hierarchicalLabel: 'sport>competition discipline>biathlon'
  },
  {
    label: 'billiards',
    parent: '20000822',
    id: '20000853',
    hierarchicalLabel: 'sport>competition discipline>billiards'
  },
  {
    label: 'bobsleigh',
    parent: '20000822',
    id: '20000854',
    hierarchicalLabel: 'sport>competition discipline>bobsleigh'
  },
  {
    label: 'bowls and petanque',
    parent: '20000822',
    id: '20000855',
    hierarchicalLabel: 'sport>competition discipline>bowls and petanque'
  },
  {
    label: 'boxing',
    parent: '20000822',
    id: '20000856',
    hierarchicalLabel: 'sport>competition discipline>boxing'
  },
  {
    label: 'bantamweight (boxing)',
    parent: '20000856',
    id: '20000857',
    hierarchicalLabel: 'sport>competition discipline>boxing>bantamweight (boxing)'
  },
  {
    label: 'cruiserweight (boxing)',
    parent: '20000856',
    id: '20000858',
    hierarchicalLabel: 'sport>competition discipline>boxing>cruiserweight (boxing)'
  },
  {
    label: 'featherweight (boxing)',
    parent: '20000856',
    id: '20000859',
    hierarchicalLabel: 'sport>competition discipline>boxing>featherweight (boxing)'
  },
  {
    label: 'flyweight (boxing)',
    parent: '20000856',
    id: '20000860',
    hierarchicalLabel: 'sport>competition discipline>boxing>flyweight (boxing)'
  },
  {
    label: 'heavyweight (boxing)',
    parent: '20000856',
    id: '20000861',
    hierarchicalLabel: 'sport>competition discipline>boxing>heavyweight (boxing)'
  },
  {
    label: 'light flyweight (boxing)',
    parent: '20000856',
    id: '20000862',
    hierarchicalLabel: 'sport>competition discipline>boxing>light flyweight (boxing)'
  },
  {
    label: 'light-heavyweight (boxing)',
    parent: '20000856',
    id: '20000863',
    hierarchicalLabel: 'sport>competition discipline>boxing>light-heavyweight (boxing)'
  },
  {
    label: 'light-middleweight (boxing)',
    parent: '20000856',
    id: '20000864',
    hierarchicalLabel: 'sport>competition discipline>boxing>light-middleweight (boxing)'
  },
  {
    label: 'light-welterweight (boxing)',
    parent: '20000856',
    id: '20000865',
    hierarchicalLabel: 'sport>competition discipline>boxing>light-welterweight (boxing)'
  },
  {
    label: 'lightweight (boxing)',
    parent: '20000856',
    id: '20000866',
    hierarchicalLabel: 'sport>competition discipline>boxing>lightweight (boxing)'
  },
  {
    label: 'middleweight (boxing)',
    parent: '20000856',
    id: '20000867',
    hierarchicalLabel: 'sport>competition discipline>boxing>middleweight (boxing)'
  },
  {
    label: 'straw weight (boxing)',
    parent: '20000856',
    id: '20000868',
    hierarchicalLabel: 'sport>competition discipline>boxing>straw weight (boxing)'
  },
  {
    label: 'super-bantamweight (boxing)',
    parent: '20000856',
    id: '20000869',
    hierarchicalLabel: 'sport>competition discipline>boxing>super-bantamweight (boxing)'
  },
  {
    label: 'super-featherweight (boxing)',
    parent: '20000856',
    id: '20000870',
    hierarchicalLabel: 'sport>competition discipline>boxing>super-featherweight (boxing)'
  },
  {
    label: 'super-flyweight (boxing)',
    parent: '20000856',
    id: '20000871',
    hierarchicalLabel: 'sport>competition discipline>boxing>super-flyweight (boxing)'
  },
  {
    label: 'super-heavyweight (boxing)',
    parent: '20000856',
    id: '20000872',
    hierarchicalLabel: 'sport>competition discipline>boxing>super-heavyweight (boxing)'
  },
  {
    label: 'super-middleweight (boxing)',
    parent: '20000856',
    id: '20000873',
    hierarchicalLabel: 'sport>competition discipline>boxing>super-middleweight (boxing)'
  },
  {
    label: 'welterweight (boxing)',
    parent: '20000856',
    id: '20000874',
    hierarchicalLabel: 'sport>competition discipline>boxing>welterweight (boxing)'
  },
  {
    label: 'bullfighting',
    parent: '20000822',
    id: '20000875',
    hierarchicalLabel: 'sport>competition discipline>bullfighting'
  },
  {
    label: 'Canadian football',
    parent: '20000822',
    id: '20000876',
    hierarchicalLabel: 'sport>competition discipline>Canadian football'
  },
  {
    label: 'canoeing',
    parent: '20000822',
    id: '20000877',
    hierarchicalLabel: 'sport>competition discipline>canoeing'
  },
  {
    label: 'C1 (canoeing)',
    parent: '20000877',
    id: '20000878',
    hierarchicalLabel: 'sport>competition discipline>canoeing>C1 (canoeing)'
  },
  {
    label: 'C2 (canoeing)',
    parent: '20000877',
    id: '20000879',
    hierarchicalLabel: 'sport>competition discipline>canoeing>C2 (canoeing)'
  },
  {
    label: 'C4 (canoeing)',
    parent: '20000877',
    id: '20000880',
    hierarchicalLabel: 'sport>competition discipline>canoeing>C4 (canoeing)'
  },
  {
    label: 'canoe sailing',
    parent: '20000877',
    id: '20000881',
    hierarchicalLabel: 'sport>competition discipline>canoeing>canoe sailing'
  },
  {
    label: 'pontoniering',
    parent: '20000877',
    id: '20000882',
    hierarchicalLabel: 'sport>competition discipline>canoeing>pontoniering'
  },
  {
    label: 'casting (fishing)',
    parent: '20000822',
    id: '20000883',
    hierarchicalLabel: 'sport>competition discipline>casting (fishing)'
  },
  {
    label: 'mountain climbing',
    parent: '20000822',
    id: '20000884',
    hierarchicalLabel: 'sport>competition discipline>mountain climbing'
  },
  {
    label: 'ice climbing',
    parent: '20000884',
    id: '20000885',
    hierarchicalLabel: 'sport>competition discipline>mountain climbing>ice climbing'
  },
  {
    label: 'mountaineering',
    parent: '20000884',
    id: '20000886',
    hierarchicalLabel: 'sport>competition discipline>mountain climbing>mountaineering'
  },
  {
    label: 'sport climbing',
    parent: '20000884',
    id: '20000887',
    hierarchicalLabel: 'sport>competition discipline>mountain climbing>sport climbing'
  },
  {
    label: 'cricket',
    parent: '20000822',
    id: '20000888',
    hierarchicalLabel: 'sport>competition discipline>cricket'
  },
  {
    label: 'croquet',
    parent: '20000822',
    id: '20000889',
    hierarchicalLabel: 'sport>competition discipline>croquet'
  },
  {
    label: 'curling',
    parent: '20000822',
    id: '20000890',
    hierarchicalLabel: 'sport>competition discipline>curling'
  },
  {
    label: 'icestock sport',
    parent: '20000890',
    id: '20000891',
    hierarchicalLabel: 'sport>competition discipline>curling>icestock sport'
  },
  {
    label: 'cycling',
    parent: '20000822',
    id: '20000892',
    hierarchicalLabel: 'sport>competition discipline>cycling'
  },
  {
    label: 'artistic cycling',
    parent: '20000892',
    id: '20000893',
    hierarchicalLabel: 'sport>competition discipline>cycling>artistic cycling'
  },
  {
    label: 'bi-crossing',
    parent: '20000892',
    id: '20000894',
    hierarchicalLabel: 'sport>competition discipline>cycling>bi-crossing'
  },
  {
    label: 'bmx',
    parent: '20000892',
    id: '20000895',
    hierarchicalLabel: 'sport>competition discipline>cycling>bmx'
  },
  {
    label: 'cycle ball',
    parent: '20000892',
    id: '20000896',
    hierarchicalLabel: 'sport>competition discipline>cycling>cycle ball'
  },
  {
    label: 'cycle sprint race',
    parent: '20000892',
    id: '20000897',
    hierarchicalLabel: 'sport>competition discipline>cycling>cycle sprint race'
  },
  {
    label: 'cyclo-cross',
    parent: '20000892',
    id: '20000898',
    hierarchicalLabel: 'sport>competition discipline>cycling>cyclo-cross'
  },
  {
    label: 'individual pursuit (cycling)',
    parent: '20000892',
    id: '20000899',
    hierarchicalLabel: 'sport>competition discipline>cycling>individual pursuit (cycling)'
  },
  {
    label: 'individual time trial (cycling)',
    parent: '20000892',
    id: '20000900',
    hierarchicalLabel: 'sport>competition discipline>cycling>individual time trial (cycling)'
  },
  {
    label: 'Keirin',
    parent: '20000892',
    id: '20000901',
    hierarchicalLabel: 'sport>competition discipline>cycling>Keirin'
  },
  {
    label: 'Madison race',
    parent: '20000892',
    id: '20000902',
    hierarchicalLabel: 'sport>competition discipline>cycling>Madison race'
  },
  {
    label: 'mountain biking',
    parent: '20000892',
    id: '20000903',
    hierarchicalLabel: 'sport>competition discipline>cycling>mountain biking'
  },
  {
    label: 'points race (cycling)',
    parent: '20000892',
    id: '20000904',
    hierarchicalLabel: 'sport>competition discipline>cycling>points race (cycling)'
  },
  {
    label: 'road cycling',
    parent: '20000892',
    id: '20000905',
    hierarchicalLabel: 'sport>competition discipline>cycling>road cycling'
  },
  {
    label: 'cycling staging race',
    parent: '20000892',
    id: '20000906',
    hierarchicalLabel: 'sport>competition discipline>cycling>cycling staging race'
  },
  {
    label: 'team cycle sprint',
    parent: '20000892',
    id: '20000907',
    hierarchicalLabel: 'sport>competition discipline>cycling>team cycle sprint'
  },
  {
    label: 'road cycling team pursuit',
    parent: '20000892',
    id: '20000908',
    hierarchicalLabel: 'sport>competition discipline>cycling>road cycling team pursuit'
  },
  {
    label: 'team time trial (cycling)',
    parent: '20000892',
    id: '20000909',
    hierarchicalLabel: 'sport>competition discipline>cycling>team time trial (cycling)'
  },
  {
    label: 'track race (cycling)',
    parent: '20000892',
    id: '20000910',
    hierarchicalLabel: 'sport>competition discipline>cycling>track race (cycling)'
  },
  {
    label: 'competitive dancing',
    parent: '20000822',
    id: '20000911',
    hierarchicalLabel: 'sport>competition discipline>competitive dancing'
  },
  {
    label: 'darts',
    parent: '20000822',
    id: '20000912',
    hierarchicalLabel: 'sport>competition discipline>darts'
  },
  {
    label: 'diving',
    parent: '20000822',
    id: '20000913',
    hierarchicalLabel: 'sport>competition discipline>diving'
  },
  {
    label: 'platform diving',
    parent: '20000913',
    id: '20000914',
    hierarchicalLabel: 'sport>competition discipline>diving>platform diving'
  },
  {
    label: 'springboard diving',
    parent: '20000913',
    id: '20000915',
    hierarchicalLabel: 'sport>competition discipline>diving>springboard diving'
  },
  {
    label: 'synchronised diving',
    parent: '20000913',
    id: '20000916',
    hierarchicalLabel: 'sport>competition discipline>diving>synchronised diving'
  },
  {
    label: 'scuba diving',
    parent: '20000913',
    id: '20000917',
    hierarchicalLabel: 'sport>competition discipline>diving>scuba diving'
  },
  {
    label: 'subaquatics',
    parent: '20000913',
    id: '20000918',
    hierarchicalLabel: 'sport>competition discipline>diving>subaquatics'
  },
  {
    label: 'dog racing',
    parent: '20000822',
    id: '20000919',
    hierarchicalLabel: 'sport>competition discipline>dog racing'
  },
  {
    label: 'oval track dog racing',
    parent: '20000919',
    id: '20000920',
    hierarchicalLabel: 'sport>competition discipline>dog racing>oval track dog racing'
  },
  {
    label: 'dog sled racing',
    parent: '20000919',
    id: '20000921',
    hierarchicalLabel: 'sport>competition discipline>dog racing>dog sled racing'
  },
  {
    label: 'duathlon',
    parent: '20000822',
    id: '20000922',
    hierarchicalLabel: 'sport>competition discipline>duathlon'
  },
  {
    label: 'equestrianism',
    parent: '20000822',
    id: '20000923',
    hierarchicalLabel: 'sport>competition discipline>equestrianism'
  },
  {
    label: 'cross country horse riding',
    parent: '20000923',
    id: '20000924',
    hierarchicalLabel: 'sport>competition discipline>equestrianism>cross country horse riding'
  },
  {
    label: 'dressage',
    parent: '20000923',
    id: '20000925',
    hierarchicalLabel: 'sport>competition discipline>equestrianism>dressage'
  },
  {
    label: 'horse jumping',
    parent: '20000923',
    id: '20000926',
    hierarchicalLabel: 'sport>competition discipline>equestrianism>horse jumping'
  },
  {
    label: 'three day eventing',
    parent: '20000923',
    id: '20000927',
    hierarchicalLabel: 'sport>competition discipline>equestrianism>three day eventing'
  },
  {
    label: 'horse driving',
    parent: '20000923',
    id: '20000928',
    hierarchicalLabel: 'sport>competition discipline>equestrianism>horse driving'
  },
  {
    label: 'fencing',
    parent: '20000822',
    id: '20000929',
    hierarchicalLabel: 'sport>competition discipline>fencing'
  },
  {
    label: 'epee',
    parent: '20000929',
    id: '20000930',
    hierarchicalLabel: 'sport>competition discipline>fencing>epee'
  },
  {
    label: 'foil',
    parent: '20000929',
    id: '20000931',
    hierarchicalLabel: 'sport>competition discipline>fencing>foil'
  },
  {
    label: 'sabre',
    parent: '20000929',
    id: '20000932',
    hierarchicalLabel: 'sport>competition discipline>fencing>sabre'
  },
  {
    label: 'field hockey',
    parent: '20000822',
    id: '20000933',
    hierarchicalLabel: 'sport>competition discipline>field hockey'
  },
  {
    label: 'figure skating',
    parent: '20000822',
    id: '20000934',
    hierarchicalLabel: 'sport>competition discipline>figure skating'
  },
  {
    label: 'ice dance',
    parent: '20000934',
    id: '20000935',
    hierarchicalLabel: 'sport>competition discipline>figure skating>ice dance'
  },
  {
    label: 'fist ball',
    parent: '20000822',
    id: '20000936',
    hierarchicalLabel: 'sport>competition discipline>fist ball'
  },
  {
    label: 'floorball',
    parent: '20000822',
    id: '20000937',
    hierarchicalLabel: 'sport>competition discipline>floorball'
  },
  {
    label: 'flying disc',
    parent: '20000822',
    id: '20000938',
    hierarchicalLabel: 'sport>competition discipline>flying disc'
  },
  {
    label: 'Gaelic football',
    parent: '20000822',
    id: '20000939',
    hierarchicalLabel: 'sport>competition discipline>Gaelic football'
  },
  {
    label: 'golf',
    parent: '20000822',
    id: '20000940',
    hierarchicalLabel: 'sport>competition discipline>golf'
  },
  {
    label: 'mini golf',
    parent: '20000940',
    id: '20000941',
    hierarchicalLabel: 'sport>competition discipline>golf>mini golf'
  },
  {
    label: 'gymnastics',
    parent: '20000822',
    id: '20000942',
    hierarchicalLabel: 'sport>competition discipline>gymnastics'
  },
  {
    label: 'rhythmic gymnastics',
    parent: '20000942',
    id: '20000951',
    hierarchicalLabel: 'sport>competition discipline>gymnastics>rhythmic gymnastics'
  },
  {
    label: 'ball (rhythmic gymnastics)',
    parent: '20000951',
    id: '20000943',
    hierarchicalLabel: 'sport>competition discipline>gymnastics>rhythmic gymnastics>ball (rhythmic gymnastics)'
  },
  {
    label: 'clubs (rhythmic gymnastics)',
    parent: '20000951',
    id: '20000945',
    hierarchicalLabel: 'sport>competition discipline>gymnastics>rhythmic gymnastics>clubs (rhythmic gymnastics)'
  },
  {
    label: 'hoop (rhythmic gymnastics)',
    parent: '20000951',
    id: '20000947',
    hierarchicalLabel: 'sport>competition discipline>gymnastics>rhythmic gymnastics>hoop (rhythmic gymnastics)'
  },
  {
    label: 'ribbon (rhythmic gymnastics)',
    parent: '20000951',
    id: '20000952',
    hierarchicalLabel: 'sport>competition discipline>gymnastics>rhythmic gymnastics>ribbon (rhythmic gymnastics)'
  },
  {
    label: 'rope (rhythmic gymnastics)',
    parent: '20000951',
    id: '20000954',
    hierarchicalLabel: 'sport>competition discipline>gymnastics>rhythmic gymnastics>rope (rhythmic gymnastics)'
  },
  {
    label: 'trampoline',
    parent: '20000942',
    id: '20000955',
    hierarchicalLabel: 'sport>competition discipline>gymnastics>trampoline'
  },
  {
    label: 'artistic gymnastics',
    parent: '20000942',
    id: '20001152',
    hierarchicalLabel: 'sport>competition discipline>gymnastics>artistic gymnastics'
  },
  {
    label: 'beam (artistic gymnastics)',
    parent: '20001152',
    id: '20000944',
    hierarchicalLabel: 'sport>competition discipline>gymnastics>artistic gymnastics>beam (artistic gymnastics)'
  },
  {
    label: 'floor exercise (artistic gymnastics)',
    parent: '20001152',
    id: '20000946',
    hierarchicalLabel: 'sport>competition discipline>gymnastics>artistic gymnastics>floor exercise (artistic gymnastics)'
  },
  {
    label: 'horizontal bar (artistic gymnastics)',
    parent: '20001152',
    id: '20000948',
    hierarchicalLabel: 'sport>competition discipline>gymnastics>artistic gymnastics>horizontal bar (artistic gymnastics)'
  },
  {
    label: 'parallel bars (artistic gymnastics)',
    parent: '20001152',
    id: '20000949',
    hierarchicalLabel: 'sport>competition discipline>gymnastics>artistic gymnastics>parallel bars (artistic gymnastics)'
  },
  {
    label: 'pommel horse (artistic gymnastics)',
    parent: '20001152',
    id: '20000950',
    hierarchicalLabel: 'sport>competition discipline>gymnastics>artistic gymnastics>pommel horse (artistic gymnastics)'
  },
  {
    label: 'rings (artistic gymnastics)',
    parent: '20001152',
    id: '20000953',
    hierarchicalLabel: 'sport>competition discipline>gymnastics>artistic gymnastics>rings (artistic gymnastics)'
  },
  {
    label: 'uneven bars (artistic gymnastics)',
    parent: '20001152',
    id: '20000956',
    hierarchicalLabel: 'sport>competition discipline>gymnastics>artistic gymnastics>uneven bars (artistic gymnastics)'
  },
  {
    label: 'vault (artistic gymnastics)',
    parent: '20001152',
    id: '20000957',
    hierarchicalLabel: 'sport>competition discipline>gymnastics>artistic gymnastics>vault (artistic gymnastics)'
  },
  {
    label: 'handball (team)',
    parent: '20000822',
    id: '20000958',
    hierarchicalLabel: 'sport>competition discipline>handball (team)'
  },
  {
    label: 'hornuss',
    parent: '20000822',
    id: '20000959',
    hierarchicalLabel: 'sport>competition discipline>hornuss'
  },
  {
    label: 'horse racing',
    parent: '20000822',
    id: '20000960',
    hierarchicalLabel: 'sport>competition discipline>horse racing'
  },
  {
    label: 'flat racing',
    parent: '20000960',
    id: '20000961',
    hierarchicalLabel: 'sport>competition discipline>horse racing>flat racing'
  },
  {
    label: 'harness racing',
    parent: '20000960',
    id: '20000962',
    hierarchicalLabel: 'sport>competition discipline>horse racing>harness racing'
  },
  {
    label: 'steeple chase',
    parent: '20000960',
    id: '20000963',
    hierarchicalLabel: 'sport>competition discipline>horse racing>steeple chase'
  },
  {
    label: 'hurling',
    parent: '20000822',
    id: '20000964',
    hierarchicalLabel: 'sport>competition discipline>hurling'
  },
  {
    label: 'ice hockey',
    parent: '20000822',
    id: '20000965',
    hierarchicalLabel: 'sport>competition discipline>ice hockey'
  },
  {
    label: 'sledge hockey',
    parent: '20000965',
    id: '20000966',
    hierarchicalLabel: 'sport>competition discipline>ice hockey>sledge hockey'
  },
  {
    label: 'inline skating',
    parent: '20000822',
    id: '20000967',
    hierarchicalLabel: 'sport>competition discipline>inline skating'
  },
  {
    label: 'Jai Alai (Pelota)',
    parent: '20000822',
    id: '20000968',
    hierarchicalLabel: 'sport>competition discipline>Jai Alai (Pelota)'
  },
  {
    label: 'kabaddi',
    parent: '20000822',
    id: '20000978',
    hierarchicalLabel: 'sport>competition discipline>kabaddi'
  },
  {
    label: 'kayaking',
    parent: '20000822',
    id: '20000979',
    hierarchicalLabel: 'sport>competition discipline>kayaking'
  },
  {
    label: 'K1 (kayaking)',
    parent: '20000979',
    id: '20000980',
    hierarchicalLabel: 'sport>competition discipline>kayaking>K1 (kayaking)'
  },
  {
    label: 'K2 (kayaking)',
    parent: '20000979',
    id: '20000981',
    hierarchicalLabel: 'sport>competition discipline>kayaking>K2 (kayaking)'
  },
  {
    label: 'K4 (kayaking)',
    parent: '20000979',
    id: '20000982',
    hierarchicalLabel: 'sport>competition discipline>kayaking>K4 (kayaking)'
  },
  {
    label: 'lacrosse',
    parent: '20000822',
    id: '20000986',
    hierarchicalLabel: 'sport>competition discipline>lacrosse'
  },
  {
    label: 'luge',
    parent: '20000822',
    id: '20000987',
    hierarchicalLabel: 'sport>competition discipline>luge'
  },
  {
    label: 'marathon',
    parent: '20000822',
    id: '20000988',
    hierarchicalLabel: 'sport>competition discipline>marathon'
  },
  {
    label: 'modern pentathlon',
    parent: '20000822',
    id: '20000989',
    hierarchicalLabel: 'sport>competition discipline>modern pentathlon'
  },
  {
    label: 'motorboat racing',
    parent: '20000822',
    id: '20000990',
    hierarchicalLabel: 'sport>competition discipline>motorboat racing'
  },
  {
    label: 'motor car racing',
    parent: '20000822',
    id: '20000991',
    hierarchicalLabel: 'sport>competition discipline>motor car racing'
  },
  {
    label: 'endurance race',
    parent: '20000991',
    id: '20000992',
    hierarchicalLabel: 'sport>competition discipline>motor car racing>endurance race'
  },
  {
    label: 'F3000',
    parent: '20000991',
    id: '20000993',
    hierarchicalLabel: 'sport>competition discipline>motor car racing>F3000'
  },
  {
    label: 'Formula One',
    parent: '20000991',
    id: '20000994',
    hierarchicalLabel: 'sport>competition discipline>motor car racing>Formula One'
  },
  {
    label: 'Indy Racing',
    parent: '20000991',
    id: '20000995',
    hierarchicalLabel: 'sport>competition discipline>motor car racing>Indy Racing'
  },
  {
    label: 'motor car rallycross',
    parent: '20000991',
    id: '20000996',
    hierarchicalLabel: 'sport>competition discipline>motor car racing>motor car rallycross'
  },
  {
    label: 'motor car rallying',
    parent: '20000991',
    id: '20000997',
    hierarchicalLabel: 'sport>competition discipline>motor car racing>motor car rallying'
  },
  {
    label: 'motorcycling',
    parent: '20000822',
    id: '20000998',
    hierarchicalLabel: 'sport>competition discipline>motorcycling'
  },
  {
    label: 'motorcycle endurance',
    parent: '20000998',
    id: '20000999',
    hierarchicalLabel: 'sport>competition discipline>motorcycling>motorcycle endurance'
  },
  {
    label: 'enduro',
    parent: '20000998',
    id: '20001000',
    hierarchicalLabel: 'sport>competition discipline>motorcycling>enduro'
  },
  {
    label: 'grass-track',
    parent: '20000998',
    id: '20001001',
    hierarchicalLabel: 'sport>competition discipline>motorcycling>grass-track'
  },
  {
    label: 'moto-ball',
    parent: '20000998',
    id: '20001002',
    hierarchicalLabel: 'sport>competition discipline>motorcycling>moto-ball'
  },
  {
    label: 'moto-cross',
    parent: '20000998',
    id: '20001003',
    hierarchicalLabel: 'sport>competition discipline>motorcycling>moto-cross'
  },
  {
    label: 'motoGP',
    parent: '20000998',
    id: '20001004',
    hierarchicalLabel: 'sport>competition discipline>motorcycling>motoGP'
  },
  {
    label: 'motorcycle rallying',
    parent: '20000998',
    id: '20001005',
    hierarchicalLabel: 'sport>competition discipline>motorcycling>motorcycle rallying'
  },
  {
    label: 'side-cars',
    parent: '20000998',
    id: '20001006',
    hierarchicalLabel: 'sport>competition discipline>motorcycling>side-cars'
  },
  {
    label: 'speedway',
    parent: '20000998',
    id: '20001007',
    hierarchicalLabel: 'sport>competition discipline>motorcycling>speedway'
  },
  {
    label: 'motorcycling trial',
    parent: '20000998',
    id: '20001008',
    hierarchicalLabel: 'sport>competition discipline>motorcycling>motorcycling trial'
  },
  {
    label: 'netball',
    parent: '20000822',
    id: '20001010',
    hierarchicalLabel: 'sport>competition discipline>netball'
  },
  {
    label: 'orienteering',
    parent: '20000822',
    id: '20001011',
    hierarchicalLabel: 'sport>competition discipline>orienteering'
  },
  {
    label: 'ski orienteering',
    parent: '20001011',
    id: '20001012',
    hierarchicalLabel: 'sport>competition discipline>orienteering>ski orienteering'
  },
  {
    label: 'parachuting',
    parent: '20000822',
    id: '20001013',
    hierarchicalLabel: 'sport>competition discipline>parachuting'
  },
  {
    label: 'polo',
    parent: '20000822',
    id: '20001014',
    hierarchicalLabel: 'sport>competition discipline>polo'
  },
  {
    label: 'pool',
    parent: '20000822',
    id: '20001015',
    hierarchicalLabel: 'sport>competition discipline>pool'
  },
  {
    label: 'power boating',
    parent: '20000822',
    id: '20001016',
    hierarchicalLabel: 'sport>competition discipline>power boating'
  },
  {
    label: 'rodeo',
    parent: '20000822',
    id: '20001017',
    hierarchicalLabel: 'sport>competition discipline>rodeo'
  },
  {
    label: 'bareback bronc',
    parent: '20001017',
    id: '20001018',
    hierarchicalLabel: 'sport>competition discipline>rodeo>bareback bronc'
  },
  {
    label: 'barrel racing',
    parent: '20001017',
    id: '20001019',
    hierarchicalLabel: 'sport>competition discipline>rodeo>barrel racing'
  },
  {
    label: 'bull riding',
    parent: '20001017',
    id: '20001020',
    hierarchicalLabel: 'sport>competition discipline>rodeo>bull riding'
  },
  {
    label: 'bulldogging',
    parent: '20001017',
    id: '20001021',
    hierarchicalLabel: 'sport>competition discipline>rodeo>bulldogging'
  },
  {
    label: 'calf roping',
    parent: '20001017',
    id: '20001022',
    hierarchicalLabel: 'sport>competition discipline>rodeo>calf roping'
  },
  {
    label: 'goat roping',
    parent: '20001017',
    id: '20001023',
    hierarchicalLabel: 'sport>competition discipline>rodeo>goat roping'
  },
  {
    label: 'saddle bronc',
    parent: '20001017',
    id: '20001024',
    hierarchicalLabel: 'sport>competition discipline>rodeo>saddle bronc'
  },
  {
    label: 'rowing',
    parent: '20000822',
    id: '20001026',
    hierarchicalLabel: 'sport>competition discipline>rowing'
  },
  {
    label: 'coxed four',
    parent: '20001026',
    id: '20001027',
    hierarchicalLabel: 'sport>competition discipline>rowing>coxed four'
  },
  {
    label: 'coxed pair',
    parent: '20001026',
    id: '20001028',
    hierarchicalLabel: 'sport>competition discipline>rowing>coxed pair'
  },
  {
    label: 'coxless four',
    parent: '20001026',
    id: '20001029',
    hierarchicalLabel: 'sport>competition discipline>rowing>coxless four'
  },
  {
    label: 'coxless pair',
    parent: '20001026',
    id: '20001030',
    hierarchicalLabel: 'sport>competition discipline>rowing>coxless pair'
  },
  {
    label: 'double sculls',
    parent: '20001026',
    id: '20001031',
    hierarchicalLabel: 'sport>competition discipline>rowing>double sculls'
  },
  {
    label: 'coxed eight',
    parent: '20001026',
    id: '20001032',
    hierarchicalLabel: 'sport>competition discipline>rowing>coxed eight'
  },
  {
    label: 'quadruple sculls',
    parent: '20001026',
    id: '20001033',
    hierarchicalLabel: 'sport>competition discipline>rowing>quadruple sculls'
  },
  {
    label: 'single sculls',
    parent: '20001026',
    id: '20001034',
    hierarchicalLabel: 'sport>competition discipline>rowing>single sculls'
  },
  {
    label: 'sailing',
    parent: '20000822',
    id: '20001038',
    hierarchicalLabel: 'sport>competition discipline>sailing'
  },
  {
    label: 'multihull',
    parent: '20001038',
    id: '20001039',
    hierarchicalLabel: 'sport>competition discipline>sailing>multihull'
  },
  {
    label: 'dinghy',
    parent: '20001038',
    id: '20001040',
    hierarchicalLabel: 'sport>competition discipline>sailing>dinghy'
  },
  {
    label: 'keelboat',
    parent: '20001038',
    id: '20001041',
    hierarchicalLabel: 'sport>competition discipline>sailing>keelboat'
  },
  {
    label: 'sailing regatta',
    parent: '20001038',
    id: '20001042',
    hierarchicalLabel: 'sport>competition discipline>sailing>sailing regatta'
  },
  {
    label: 'ocean sailing',
    parent: '20001038',
    id: '20001043',
    hierarchicalLabel: 'sport>competition discipline>sailing>ocean sailing'
  },
  {
    label: 'round the world race',
    parent: '20001038',
    id: '20001044',
    hierarchicalLabel: 'sport>competition discipline>sailing>round the world race'
  },
  {
    label: 'solo ocean sailing',
    parent: '20001038',
    id: '20001045',
    hierarchicalLabel: 'sport>competition discipline>sailing>solo ocean sailing'
  },
  {
    label: 'non-stop solo race',
    parent: '20001038',
    id: '20001046',
    hierarchicalLabel: 'sport>competition discipline>sailing>non-stop solo race'
  },
  {
    label: 'sepak takraw',
    parent: '20000822',
    id: '20001047',
    hierarchicalLabel: 'sport>competition discipline>sepak takraw'
  },
  {
    label: 'shinty',
    parent: '20000822',
    id: '20001048',
    hierarchicalLabel: 'sport>competition discipline>shinty'
  },
  {
    label: 'sport shooting',
    parent: '20000822',
    id: '20001049',
    hierarchicalLabel: 'sport>competition discipline>sport shooting'
  },
  {
    label: 'pistol shooting',
    parent: '20001049',
    id: '20001050',
    hierarchicalLabel: 'sport>competition discipline>sport shooting>pistol shooting'
  },
  {
    label: 'rifle shooting',
    parent: '20001049',
    id: '20001051',
    hierarchicalLabel: 'sport>competition discipline>sport shooting>rifle shooting'
  },
  {
    label: 'running target shooting',
    parent: '20001049',
    id: '20001052',
    hierarchicalLabel: 'sport>competition discipline>sport shooting>running target shooting'
  },
  {
    label: 'shotgun shooting',
    parent: '20001049',
    id: '20001053',
    hierarchicalLabel: 'sport>competition discipline>sport shooting>shotgun shooting'
  },
  {
    label: 'clay pigeon shooting',
    parent: '20001049',
    id: '20001054',
    hierarchicalLabel: 'sport>competition discipline>sport shooting>clay pigeon shooting'
  },
  {
    label: 'skeleton',
    parent: '20000822',
    id: '20001055',
    hierarchicalLabel: 'sport>competition discipline>skeleton'
  },
  {
    label: 'skiing',
    parent: '20000822',
    id: '20001056',
    hierarchicalLabel: 'sport>competition discipline>skiing'
  },
  {
    label: 'alpine skiing',
    parent: '20001056',
    id: '20001057',
    hierarchicalLabel: 'sport>competition discipline>skiing>alpine skiing'
  },
  {
    label: 'freestyle skiing',
    parent: '20001056',
    id: '20001058',
    hierarchicalLabel: 'sport>competition discipline>skiing>freestyle skiing'
  },
  {
    label: 'grass skiing',
    parent: '20001056',
    id: '20001059',
    hierarchicalLabel: 'sport>competition discipline>skiing>grass skiing'
  },
  {
    label: 'Nordic skiing',
    parent: '20001056',
    id: '20001060',
    hierarchicalLabel: 'sport>competition discipline>skiing>Nordic skiing'
  },
  {
    label: 'cross-country skiing',
    parent: '20001060',
    id: '20001149',
    hierarchicalLabel: 'sport>competition discipline>skiing>Nordic skiing>cross-country skiing'
  },
  {
    label: 'Nordic combined',
    parent: '20001060',
    id: '20001150',
    hierarchicalLabel: 'sport>competition discipline>skiing>Nordic skiing>Nordic combined'
  },
  {
    label: 'ski jumping',
    parent: '20001056',
    id: '20001061',
    hierarchicalLabel: 'sport>competition discipline>skiing>ski jumping'
  },
  {
    label: 'Telemark skiing',
    parent: '20001056',
    id: '20001153',
    hierarchicalLabel: 'sport>competition discipline>skiing>Telemark skiing'
  },
  {
    label: 'sky diving',
    parent: '20000822',
    id: '20001062',
    hierarchicalLabel: 'sport>competition discipline>sky diving'
  },
  {
    label: 'snooker',
    parent: '20000822',
    id: '20001063',
    hierarchicalLabel: 'sport>competition discipline>snooker'
  },
  {
    label: 'snowboarding',
    parent: '20000822',
    id: '20001064',
    hierarchicalLabel: 'sport>competition discipline>snowboarding'
  },
  {
    label: 'soccer',
    parent: '20000822',
    id: '20001065',
    hierarchicalLabel: 'sport>competition discipline>soccer'
  },
  {
    label: 'softball',
    parent: '20000822',
    id: '20001066',
    hierarchicalLabel: 'sport>competition discipline>softball'
  },
  {
    label: 'speed skating',
    parent: '20000822',
    id: '20001067',
    hierarchicalLabel: 'sport>competition discipline>speed skating'
  },
  {
    label: 'squash',
    parent: '20000822',
    id: '20001068',
    hierarchicalLabel: 'sport>competition discipline>squash'
  },
  {
    label: 'sumo wrestling',
    parent: '20000822',
    id: '20001069',
    hierarchicalLabel: 'sport>competition discipline>sumo wrestling'
  },
  {
    label: 'surfing',
    parent: '20000822',
    id: '20001070',
    hierarchicalLabel: 'sport>competition discipline>surfing'
  },
  {
    label: 'swimming',
    parent: '20000822',
    id: '20001071',
    hierarchicalLabel: 'sport>competition discipline>swimming'
  },
  {
    label: 'backstroke',
    parent: '20001071',
    id: '20001072',
    hierarchicalLabel: 'sport>competition discipline>swimming>backstroke'
  },
  {
    label: 'breaststroke',
    parent: '20001071',
    id: '20001073',
    hierarchicalLabel: 'sport>competition discipline>swimming>breaststroke'
  },
  {
    label: 'butterfly swimming',
    parent: '20001071',
    id: '20001074',
    hierarchicalLabel: 'sport>competition discipline>swimming>butterfly swimming'
  },
  {
    label: 'freestyle swimming',
    parent: '20001071',
    id: '20001075',
    hierarchicalLabel: 'sport>competition discipline>swimming>freestyle swimming'
  },
  {
    label: 'medley swimming',
    parent: '20001071',
    id: '20001076',
    hierarchicalLabel: 'sport>competition discipline>swimming>medley swimming'
  },
  {
    label: 'marathon swimming',
    parent: '20001071',
    id: '20001077',
    hierarchicalLabel: 'sport>competition discipline>swimming>marathon swimming'
  },
  {
    label: 'relay freestyle swimming',
    parent: '20001071',
    id: '20001078',
    hierarchicalLabel: 'sport>competition discipline>swimming>relay freestyle swimming'
  },
  {
    label: 'relay medley swimming',
    parent: '20001071',
    id: '20001079',
    hierarchicalLabel: 'sport>competition discipline>swimming>relay medley swimming'
  },
  {
    label: 'short course swimming',
    parent: '20001071',
    id: '20001080',
    hierarchicalLabel: 'sport>competition discipline>swimming>short course swimming'
  },
  {
    label: 'table tennis',
    parent: '20000822',
    id: '20001083',
    hierarchicalLabel: 'sport>competition discipline>table tennis'
  },
  {
    label: 'tennis',
    parent: '20000822',
    id: '20001085',
    hierarchicalLabel: 'sport>competition discipline>tennis'
  },
  {
    label: 'ten pin bowling',
    parent: '20000822',
    id: '20001086',
    hierarchicalLabel: 'sport>competition discipline>ten pin bowling'
  },
  {
    label: 'triathlon',
    parent: '20000822',
    id: '20001087',
    hierarchicalLabel: 'sport>competition discipline>triathlon'
  },
  {
    label: 'tug-of-war',
    parent: '20000822',
    id: '20001088',
    hierarchicalLabel: 'sport>competition discipline>tug-of-war'
  },
  {
    label: 'volleyball',
    parent: '20000822',
    id: '20001089',
    hierarchicalLabel: 'sport>competition discipline>volleyball'
  },
  {
    label: 'beach volleyball',
    parent: '20001089',
    id: '20001090',
    hierarchicalLabel: 'sport>competition discipline>volleyball>beach volleyball'
  },
  {
    label: 'water polo',
    parent: '20000822',
    id: '20001091',
    hierarchicalLabel: 'sport>competition discipline>water polo'
  },
  {
    label: 'water skiing',
    parent: '20000822',
    id: '20001092',
    hierarchicalLabel: 'sport>competition discipline>water skiing'
  },
  {
    label: 'weightlifting',
    parent: '20000822',
    id: '20001093',
    hierarchicalLabel: 'sport>competition discipline>weightlifting'
  },
  {
    label: 'clean and jerk (weightlifting)',
    parent: '20001093',
    id: '20001094',
    hierarchicalLabel: 'sport>competition discipline>weightlifting>clean and jerk (weightlifting)'
  },
  {
    label: 'powerlifting',
    parent: '20001093',
    id: '20001095',
    hierarchicalLabel: 'sport>competition discipline>weightlifting>powerlifting'
  },
  {
    label: 'snatch (weightlifting)',
    parent: '20001093',
    id: '20001096',
    hierarchicalLabel: 'sport>competition discipline>weightlifting>snatch (weightlifting)'
  },
  {
    label: 'windsurfing',
    parent: '20000822',
    id: '20001097',
    hierarchicalLabel: 'sport>competition discipline>windsurfing'
  },
  {
    label: 'wrestling',
    parent: '20000822',
    id: '20001098',
    hierarchicalLabel: 'sport>competition discipline>wrestling'
  },
  {
    label: 'freestyle wrestling',
    parent: '20001098',
    id: '20001099',
    hierarchicalLabel: 'sport>competition discipline>wrestling>freestyle wrestling'
  },
  {
    label: 'greco-roman',
    parent: '20001098',
    id: '20001100',
    hierarchicalLabel: 'sport>competition discipline>wrestling>greco-roman'
  },
  {
    label: 'Swiss wrestling',
    parent: '20001098',
    id: '20001101',
    hierarchicalLabel: 'sport>competition discipline>wrestling>Swiss wrestling'
  },
  {
    label: 'short track speed skating',
    parent: '20000822',
    id: '20001151',
    hierarchicalLabel: 'sport>competition discipline>short track speed skating'
  },
  {
    label: 'chess',
    parent: '20000822',
    id: '20001154',
    hierarchicalLabel: 'sport>competition discipline>chess'
  },
  {
    label: 'roller sports',
    parent: '20000822',
    id: '20001155',
    hierarchicalLabel: 'sport>competition discipline>roller sports'
  },
  {
    label: 'roller hockey',
    parent: '20001155',
    id: '20001025',
    hierarchicalLabel: 'sport>competition discipline>roller sports>roller hockey'
  },
  {
    label: 'skateboarding',
    parent: '20001155',
    id: '20001156',
    hierarchicalLabel: 'sport>competition discipline>roller sports>skateboarding'
  },
  {
    label: 'martial arts',
    parent: '20000822',
    id: '20001157',
    hierarchicalLabel: 'sport>competition discipline>martial arts'
  },
  {
    label: 'judo',
    parent: '20001157',
    id: '20000969',
    hierarchicalLabel: 'sport>competition discipline>martial arts>judo'
  },
  {
    label: 'extra lightweight (judo)',
    parent: '20000969',
    id: '20000970',
    hierarchicalLabel: 'sport>competition discipline>martial arts>judo>extra lightweight (judo)'
  },
  {
    label: 'half-heavyweight (judo)',
    parent: '20000969',
    id: '20000971',
    hierarchicalLabel: 'sport>competition discipline>martial arts>judo>half-heavyweight (judo)'
  },
  {
    label: 'half-lightweight (judo)',
    parent: '20000969',
    id: '20000972',
    hierarchicalLabel: 'sport>competition discipline>martial arts>judo>half-lightweight (judo)'
  },
  {
    label: 'half-middleweight (judo)',
    parent: '20000969',
    id: '20000973',
    hierarchicalLabel: 'sport>competition discipline>martial arts>judo>half-middleweight (judo)'
  },
  {
    label: 'heavyweight (judo)',
    parent: '20000969',
    id: '20000974',
    hierarchicalLabel: 'sport>competition discipline>martial arts>judo>heavyweight (judo)'
  },
  {
    label: 'lightweight (judo)',
    parent: '20000969',
    id: '20000975',
    hierarchicalLabel: 'sport>competition discipline>martial arts>judo>lightweight (judo)'
  },
  {
    label: 'middleweight (judo)',
    parent: '20000969',
    id: '20000976',
    hierarchicalLabel: 'sport>competition discipline>martial arts>judo>middleweight (judo)'
  },
  {
    label: 'jukendo',
    parent: '20001157',
    id: '20000977',
    hierarchicalLabel: 'sport>competition discipline>martial arts>jukendo'
  },
  {
    label: 'karate',
    parent: '20001157',
    id: '20000983',
    hierarchicalLabel: 'sport>competition discipline>martial arts>karate'
  },
  {
    label: 'kendo',
    parent: '20001157',
    id: '20000984',
    hierarchicalLabel: 'sport>competition discipline>martial arts>kendo'
  },
  {
    label: 'kyudo',
    parent: '20001157',
    id: '20000985',
    hierarchicalLabel: 'sport>competition discipline>martial arts>kyudo'
  },
  {
    label: 'naginata',
    parent: '20001157',
    id: '20001009',
    hierarchicalLabel: 'sport>competition discipline>martial arts>naginata'
  },
  {
    label: 'Taekwon-Do',
    parent: '20001157',
    id: '20001084',
    hierarchicalLabel: 'sport>competition discipline>martial arts>Taekwon-Do'
  },
  {
    label: 'wushu',
    parent: '20001157',
    id: '20001102',
    hierarchicalLabel: 'sport>competition discipline>martial arts>wushu'
  },
  {
    label: 'synchronised swimming',
    parent: '20000822',
    id: '20001175',
    hierarchicalLabel: 'sport>competition discipline>synchronised swimming'
  },
  {
    label: 'synchronised free routine',
    parent: '20001175',
    id: '20001081',
    hierarchicalLabel: 'sport>competition discipline>synchronised swimming>synchronised free routine'
  },
  {
    label: 'synchronised technical routine',
    parent: '20001175',
    id: '20001082',
    hierarchicalLabel: 'sport>competition discipline>synchronised swimming>synchronised technical routine'
  },
  {
    label: 'rugby',
    parent: '20000822',
    id: '20001176',
    hierarchicalLabel: 'sport>competition discipline>rugby'
  },
  {
    label: 'rugby league',
    parent: '20001176',
    id: '20001035',
    hierarchicalLabel: 'sport>competition discipline>rugby>rugby league'
  },
  {
    label: 'rugby union',
    parent: '20001176',
    id: '20001036',
    hierarchicalLabel: 'sport>competition discipline>rugby>rugby union'
  },
  {
    label: 'rugby sevens',
    parent: '20001176',
    id: '20001037',
    hierarchicalLabel: 'sport>competition discipline>rugby>rugby sevens'
  },
  {
    label: 'disciplinary action in sport',
    parent: '15000000',
    id: '20001103',
    hierarchicalLabel: 'sport>disciplinary action in sport'
  },
  {
    label: 'drug use in sport',
    parent: '15000000',
    id: '20001104',
    hierarchicalLabel: 'sport>drug use in sport'
  },
  {
    label: 'drug abuse in sport',
    parent: '20001104',
    id: '20001105',
    hierarchicalLabel: 'sport>drug use in sport>drug abuse in sport'
  },
  {
    label: 'drug testing in sport',
    parent: '20001104',
    id: '20001106',
    hierarchicalLabel: 'sport>drug use in sport>drug testing in sport'
  },
  {
    label: 'medical drug use in sport',
    parent: '20001104',
    id: '20001107',
    hierarchicalLabel: 'sport>drug use in sport>medical drug use in sport'
  },
  {
    label: 'sport event',
    parent: '15000000',
    id: '20001108',
    hierarchicalLabel: 'sport>sport event'
  },
  {
    label: 'continental championship',
    parent: '20001108',
    id: '20001109',
    hierarchicalLabel: 'sport>sport event>continental championship'
  },
  {
    label: 'continental cup',
    parent: '20001108',
    id: '20001110',
    hierarchicalLabel: 'sport>sport event>continental cup'
  },
  {
    label: 'continental games',
    parent: '20001108',
    id: '20001111',
    hierarchicalLabel: 'sport>sport event>continental games'
  },
  {
    label: 'international championship',
    parent: '20001108',
    id: '20001112',
    hierarchicalLabel: 'sport>sport event>international championship'
  },
  {
    label: 'international cup',
    parent: '20001108',
    id: '20001113',
    hierarchicalLabel: 'sport>sport event>international cup'
  },
  {
    label: 'international games',
    parent: '20001108',
    id: '20001114',
    hierarchicalLabel: 'sport>sport event>international games'
  },
  {
    label: 'national championship',
    parent: '20001108',
    id: '20001115',
    hierarchicalLabel: 'sport>sport event>national championship'
  },
  {
    label: 'national cup',
    parent: '20001108',
    id: '20001116',
    hierarchicalLabel: 'sport>sport event>national cup'
  },
  {
    label: 'national games',
    parent: '20001108',
    id: '20001117',
    hierarchicalLabel: 'sport>sport event>national games'
  },
  {
    label: 'regional championship',
    parent: '20001108',
    id: '20001118',
    hierarchicalLabel: 'sport>sport event>regional championship'
  },
  {
    label: 'regional cup',
    parent: '20001108',
    id: '20001119',
    hierarchicalLabel: 'sport>sport event>regional cup'
  },
  {
    label: 'regional games',
    parent: '20001108',
    id: '20001120',
    hierarchicalLabel: 'sport>sport event>regional games'
  },
  {
    label: 'world championship',
    parent: '20001108',
    id: '20001121',
    hierarchicalLabel: 'sport>sport event>world championship'
  },
  {
    label: 'world cup',
    parent: '20001108',
    id: '20001122',
    hierarchicalLabel: 'sport>sport event>world cup'
  },
  {
    label: 'world games',
    parent: '20001108',
    id: '20001123',
    hierarchicalLabel: 'sport>sport event>world games'
  },
  {
    label: 'Olympic Games',
    parent: '20001123',
    id: '20001177',
    hierarchicalLabel: 'sport>sport event>world games>Olympic Games'
  },
  {
    label: 'Paralympic Games',
    parent: '20001123',
    id: '20001178',
    hierarchicalLabel: 'sport>sport event>world games>Paralympic Games'
  },
  {
    label: 'sport industry',
    parent: '15000000',
    id: '20001124',
    hierarchicalLabel: 'sport>sport industry'
  },
  {
    label: 'sport organisation',
    parent: '15000000',
    id: '20001125',
    hierarchicalLabel: 'sport>sport organisation'
  },
  {
    label: 'sport venue',
    parent: '15000000',
    id: '20001126',
    hierarchicalLabel: 'sport>sport venue'
  },
  {
    label: 'transfer',
    parent: '15000000',
    id: '20001148',
    hierarchicalLabel: 'sport>transfer'
  },
  {
    label: 'conflicts, war and peace',
    parent: null,
    id: '16000000',
    hierarchicalLabel: 'conflicts, war and peace'
  },
  {
    label: 'act of terror',
    parent: '16000000',
    id: '20000053',
    hierarchicalLabel: 'conflicts, war and peace>act of terror'
  },
  {
    label: 'act of bioterrorism',
    parent: '20000053',
    id: '20000054',
    hierarchicalLabel: 'conflicts, war and peace>act of terror>act of bioterrorism'
  },
  {
    label: 'bombings',
    parent: '20000053',
    id: '20000055',
    hierarchicalLabel: 'conflicts, war and peace>act of terror>bombings'
  },
  {
    label: 'armed conflict',
    parent: '16000000',
    id: '20000056',
    hierarchicalLabel: 'conflicts, war and peace>armed conflict'
  },
  {
    label: 'guerrilla activity',
    parent: '20000056',
    id: '20000057',
    hierarchicalLabel: 'conflicts, war and peace>armed conflict>guerrilla activity'
  },
  {
    label: 'international military intervention',
    parent: '20000056',
    id: '20000058',
    hierarchicalLabel: 'conflicts, war and peace>armed conflict>international military intervention'
  },
  {
    label: 'peacekeeping force',
    parent: '20000058',
    id: '20000059',
    hierarchicalLabel: 'conflicts, war and peace>armed conflict>international military intervention>peacekeeping force'
  },
  {
    label: 'military occupation',
    parent: '20000056',
    id: '20000060',
    hierarchicalLabel: 'conflicts, war and peace>armed conflict>military occupation'
  },
  {
    label: 'missing due to hostilities',
    parent: '20000056',
    id: '20000061',
    hierarchicalLabel: 'conflicts, war and peace>armed conflict>missing due to hostilities'
  },
  {
    label: 'war',
    parent: '20000056',
    id: '20000062',
    hierarchicalLabel: 'conflicts, war and peace>armed conflict>war'
  },
  {
    label: 'civil war',
    parent: '20000062',
    id: '20000063',
    hierarchicalLabel: 'conflicts, war and peace>armed conflict>war>civil war'
  },
  {
    label: 'war crime action',
    parent: '20000062',
    id: '20000064',
    hierarchicalLabel: 'conflicts, war and peace>armed conflict>war>war crime action'
  },
  {
    label: 'civil unrest',
    parent: '16000000',
    id: '20000065',
    hierarchicalLabel: 'conflicts, war and peace>civil unrest'
  },
  {
    label: 'demonstration',
    parent: '20000065',
    id: '20000066',
    hierarchicalLabel: 'conflicts, war and peace>civil unrest>demonstration'
  },
  {
    label: 'rebellion',
    parent: '20000065',
    id: '20000067',
    hierarchicalLabel: 'conflicts, war and peace>civil unrest>rebellion'
  },
  {
    label: 'revolution',
    parent: '20000065',
    id: '20000068',
    hierarchicalLabel: 'conflicts, war and peace>civil unrest>revolution'
  },
  {
    label: 'riot',
    parent: '20000065',
    id: '20000069',
    hierarchicalLabel: 'conflicts, war and peace>civil unrest>riot'
  },
  {
    label: "coup d'etat",
    parent: '16000000',
    id: '20000070',
    hierarchicalLabel: "conflicts, war and peace>coup d'etat"
  },
  {
    label: 'massacre',
    parent: '16000000',
    id: '20000071',
    hierarchicalLabel: 'conflicts, war and peace>massacre'
  },
  {
    label: 'genocide',
    parent: '20000071',
    id: '20000072',
    hierarchicalLabel: 'conflicts, war and peace>massacre>genocide'
  },
  {
    label: 'peace process',
    parent: '16000000',
    id: '20000073',
    hierarchicalLabel: 'conflicts, war and peace>peace process'
  },
  {
    label: 'peace envoy',
    parent: '20000073',
    id: '20000074',
    hierarchicalLabel: 'conflicts, war and peace>peace process>peace envoy'
  },
  {
    label: 'peace plan',
    parent: '20000073',
    id: '20000075',
    hierarchicalLabel: 'conflicts, war and peace>peace process>peace plan'
  },
  {
    label: 'peace talks',
    parent: '20000073',
    id: '20000076',
    hierarchicalLabel: 'conflicts, war and peace>peace process>peace talks'
  },
  {
    label: 'post-war reconstruction',
    parent: '16000000',
    id: '20000077',
    hierarchicalLabel: 'conflicts, war and peace>post-war reconstruction'
  },
  {
    label: 'disarmament',
    parent: '20000077',
    id: '20000078',
    hierarchicalLabel: 'conflicts, war and peace>post-war reconstruction>disarmament'
  },
  {
    label: 'ordnance clearance',
    parent: '20000077',
    id: '20000079',
    hierarchicalLabel: 'conflicts, war and peace>post-war reconstruction>ordnance clearance'
  },
  {
    label: 'prisoners and detainees',
    parent: '16000000',
    id: '20000080',
    hierarchicalLabel: 'conflicts, war and peace>prisoners and detainees'
  },
  {
    label: 'weather',
    parent: null,
    id: '17000000',
    hierarchicalLabel: 'weather'
  },
  {
    label: 'weather forecast',
    parent: '17000000',
    id: '20001128',
    hierarchicalLabel: 'weather>weather forecast'
  },
  {
    label: 'weather phenomena',
    parent: '17000000',
    id: '20001129',
    hierarchicalLabel: 'weather>weather phenomena'
  },
  {
    label: 'weather statistic',
    parent: '17000000',
    id: '20001130',
    hierarchicalLabel: 'weather>weather statistic'
  },
  {
    label: 'weather warning',
    parent: '17000000',
    id: '20001131',
    hierarchicalLabel: 'weather>weather warning'
  }
];
